import {
  Button,
  Container,
  Divider,
  Grid,
  Typography,
  Paper,
  DialogContentText,
  DialogActions,
  TextField,
  Stack,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  CircularProgress,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from 'react';
import Box from '@mui/material/Box';
import footer from '../../../assets/background.png';
import { CustomButton } from '@tabletuck/components';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PersonIcon from '@mui/icons-material/Person';
import { makeStyles } from '@mui/styles';
import Radio from '@mui/material/Radio';
import PaymentsDialog from './dialog';
import NewPaymet from './NewPaymet';
import SquareCashAppPay from '../../components/SquareCashAppPay/SquareCashAppPay';
import SquareApplePay from '../../components/SquareApplePay/SquareApplePay';
import SquareGooglePay from '../../components/SquareGooglePay/SquareGooglePay';
import PaymentMethodDialog from '../../components/PaymentMethodDialog/PaymentMethodDialog';
import SchedulingDialog from '../../components/SchedulingDialog/SchedulingDialog';

import axios from 'axios';
import OrderSummary from '../../components/Checkout/OrderSummary';
import { useDispatch } from 'react-redux';
import {
  auth,
  firestore,
  RootFirestore,
  recaptchaVerifier,
  _customApp,
} from '../../../../../../libs/firebase-service/src';
import firebase from 'firebase';
import {
  getTimeZones,
  getTomorrow,
  getTomorrowScheduleLater,
  convertStoreTimeToUserLocal,
  formatTimeSlotForUser,
  getTimezoneDisplayInfo,
  convertUserTimeToUTC,
} from './utils';
import Snipper from '/libs/components/src/lib/snipper/Snipper';
import SuccessDialog from './successDialog';
import { useTheme } from '@mui/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useSelector } from 'react-redux';
import ErrorIcon from '@mui/icons-material/Error';
import PhoneInternational from '../../components/PhoneNumber/phoneinternational';
import {
  isValidPhoneNumber,
  formatPhoneNumber,
} from 'react-phone-number-input';
import ReactCodeInput from 'react-code-input';
import Loading from 'react-fullscreen-loading';

import {
  setCart,
  setUser,
  UdpateNote,
  UpdateCartData,
  UpdateScheduledTime,
  loggedInSuccess,
  setAnonymousStatus,
  setDeliveryStore,
} from '../../../../../../libs/redux-slices/src';
import { environment } from '../../../environments/environment';
import { useTranslation } from 'react-i18next';
import { fetchData, handleToaster } from '../../Utils/UtilsFunctions';
import { ToastContainer } from 'react-toastify';
import SectionHeader from '../../components/common/SectionHeader';
import NeedQuestion from '../../components/NeedQuestion';
import RedeemPoints from '../../components/RedeemPoints/RedeemPoints';
import { useLocation, useNavigate } from 'react-router';
import { IoTime } from 'react-icons/io5';
import { useAnonymousAuth } from '../../hooks/useAnonymousAuth';
import { useDeliveryAddress } from '../../hooks/useDeliveryAddress';
import { FaApplePay, FaGooglePay } from 'react-icons/fa';
import { FcGoogle } from 'react-icons/fc';
const tomorrow = 'tomorrow';
const today = 'today';
const afterTomorrow = 'afterTomorrow';

const useStyles = makeStyles((theme) => ({
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  flexJustifyCenter: {
    display: 'flex',
    justifyContent: 'center',
  },
  flexFullWidth: {
    display: 'flex',
    width: '100%',
  },
  btnContainer: {
    width: 250,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    fontSize: 20,
    height: 40,
    padding: 10,
    borderRadius: 10,
  },
  confirmButton: {
    backgroundColor: 'lightgray',
    fontSize: 12,
    fontWeight: 'bold',
    padding: 10,
    height: 50,
    paddingRight: '10px',
  },
}));

const ConfirmOrderPage = ({ typo, store }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const classes = useStyles();
  const dispatch = useDispatch();
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));
  const [t, i18n] = useTranslation();

  const [slots, setSlots] = useState({});

  const [StoreData, setStoreData] = useState({});
  const [range, setRange] = useState({
    today: '',
    tomorrow: '',
    afterTomorrow: '',
  });
  const [openSucess, setOpenSuccess] = useState(false);
  const [selectedTime, setSelectedTime] = useState({});
  const [unavailableNow, setUnAvailableNow] = useState(true);

  const [isBusy, setIsBusy] = useState(false);

  const [asap, setAsap] = useState('15 min');
  const [prev, setPrev] = useState('');
  const [err, setErr] = React.useState('');
  const [change, setChange] = React.useState(null);

  const [realTime, setRealTime] = useState(null);
  const defauldAdd = useSelector((state) => state.shopReducer.defauldAdd);

  const defaultStore = useSelector((state) => state.shopReducer.defaultStore);

  const defaultStorefee = useSelector(
    (state) => state.shopReducer.defaultStorefee
  );

  const [defaultStoreAdress, setDefaultStoreAdress] = useState('');

  // Get full cartData and destructure needed properties
  const cartData = useSelector((state) => state.shopReducer.cartData); // Full cartData object for logging
  const reduxScheduledTime = useSelector(
    (state) => state.shopReducer.scheduledTime
  );
  const user = useSelector((state) => state.authReducer.userData);
  const {
    orderType,
    typeAddress,
    code,
    storeId,
    discount,
    apiPricingData,
    scheduledTime: cartDataScheduledTime,
  } = cartData;
  // Prefer cartData.scheduledTime; fall back to redux scheduledTime when coming from Locations/LocationDetails/changeBranchMenu
  const scheduledTime = useMemo(() => {
    const sid =
      user?.bagItems?.[0]?.storeId ??
      user?.bagItems?.[0]?.store_id ??
      cartData?.storeId ??
      storeId ??
      '';
    const fromCart = cartDataScheduledTime?.storeId === sid;
    const fromRedux = reduxScheduledTime?.storeId === sid;
    // Prefer redux over cart when both exist - redux has the live selection from
    // scheduling dialogs; cartData may be stale from a previous session
    let result = cartDataScheduledTime;
    if (fromRedux && (reduxScheduledTime?.dateOfOrder || reduxScheduledTime?.isAsap))
      result = reduxScheduledTime;
    else if (fromCart && (cartDataScheduledTime?.dateOfOrder || cartDataScheduledTime?.isAsap))
      result = cartDataScheduledTime;
    return result;
  }, [
    cartDataScheduledTime,
    reduxScheduledTime,
    user?.bagItems,
    cartData?.storeId,
    storeId,
  ]);
  const deliveryStore = useSelector((state) => state.shopReducer.deliveryStore);
  const note = useSelector((state) => state.shopReducer.note);
  const deliveryAddress = useSelector(
    (state) => state.shopReducer.deliveryAddress
  );

  const [selectedValue, setSelectedValue] = React.useState(
    scheduledTime?.isAsap ? 'a' : scheduledTime?.dateOfOrder ? 'b' : null
  );

  // Dialog shown when user tries to place an order with an expired scheduled slot
  const [rescheduleDialogOpen, setRescheduleDialogOpen] = useState(false);

  // True when user had a scheduled (non-ASAP) slot that has now passed
  const isScheduleExpired =
    selectedValue === 'b' &&
    (!scheduledTime?.dateOfOrder ||
      new Date(scheduledTime.dateOfOrder) < new Date());

  // Keep a stable ref so the expiry effect can read cartData without re-running on every cartData change
  const cartDataRef = useRef(cartData);
  useEffect(() => { cartDataRef.current = cartData; }, [cartData]);

  // Clear scheduled time the moment it expires.
  // Strategy: check immediately on mount, set a precise timeout to the exact expiry,
  // and re-check on tab focus (browser throttles timers in background tabs).
  useEffect(() => {
    if (!scheduledTime?.dateOfOrder) return;

    const clear = () => {
      dispatch(UpdateScheduledTime(null));
      dispatch(UpdateCartData({ ...cartDataRef.current, scheduledTime: null }));
      // Keep selectedValue === 'b' so isScheduleExpired stays true and the
      // reschedule intercept fires when the user next clicks "Place Your Order".
      // Do NOT reset selectedValue to null here.
    };

    const msUntilExpiry = new Date(scheduledTime.dateOfOrder) - Date.now();
    if (msUntilExpiry <= 0) {
      clear();
      return;
    }

    const timer = setTimeout(clear, msUntilExpiry);
    window.addEventListener('focus', checkIfExpired);

    function checkIfExpired() {
      if (new Date(scheduledTime.dateOfOrder) < new Date()) clear();
    }

    return () => {
      clearTimeout(timer);
      window.removeEventListener('focus', checkIfExpired);
    };
  }, [scheduledTime?.dateOfOrder, dispatch]);

  const [typeTip, setTypeTip] = React.useState(null);
  const [scheduleOrderEnabled, setScheduleOrderEnabled] = useState(false);
  const [tipAmount, setTipsAmount] = useState(0); // Will be set to 10% after initial pricing loads

  const [otherTip, setOtherTip] = useState(0);

  const [stateTxt, setStateTxt] = useState('');

  const [userCard, setUserCard] = useState();

  const [dateOfOrder, setDateOfOrder] = useState(null);

  const [loading, setLoading] = useState(false);

  const [selectedOffer, setSelectedOffer] = useState(null);
  const [selectedRewardItemId, setSelectedRewardItemId] = useState(null);
  const [programOffers, setProgramOffers] = useState([]);
  const [loyaltyData, setLoyaltyData] = useState(null);
  const [openD, setD] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openCredit, setOpenCredit] = useState(false);
  const tableNo = useSelector((state) => state.shopReducer.tableNo);
  const [data, setData] = useState([]);
  const [storeIdD, setStoreId] = useState('');
  const reduxCart = useSelector((state) => state.shopReducer.cart); // Current cart items in Redux
  const categories = useSelector(
    (state) => state.shopReducer.currentCategories
  ); // Menu categories with availability periods

  // When true, checkout time slots are additionally constrained by the
  // availability windows of at least one item/category in the cart.
  const [hasItemAvailabilityConstraints, setHasItemAvailabilityConstraints] =
    useState(false);
  const [availabilityCategoryNames, setAvailabilityCategoryNames] = useState(
    []
  );
  const lastAvailabilityCategoryNamesRef = useRef([]);
  const stores = useSelector((state) => state.shopReducer.stores);
  const [env, setEnv] = useState([]);
  const [errAmount, setErrAmount] = useState('');
  const [classroomNumber, setClassroomNumber] = useState('');
  const [cash, setCash] = useState(false);
  const hasCatering = user?.bagItems?.some((item) => item.isCatering) || false;
  const [sendTime, setSendTime] = useState(hasCatering ? tomorrow : today);
  const [cards, setCards] = useState([]);
  const [marketingOptIn, setMarketingOptIn] = useState(false);
  const [activeorders, setActiveorders] = useState('');
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [paymentMethodDialog, setPaymentMethodDialog] = useState(false);
  const [timezoneInfo, setTimezoneInfo] = useState(null);

  const [sourceId, setSourceId] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(''); // 'CARD' | 'CASH_APP' | 'APPLE_PAY' | 'GOOGLE_PAY'

  // Use refs to ensure payment method and sourceId are available immediately
  const paymentMethodRef = useRef('');
  const sourceIdRef = useRef(null);

  // Keep refs in sync with state
  useEffect(() => {
    paymentMethodRef.current = paymentMethod;
  }, [paymentMethod]);

  useEffect(() => {
    sourceIdRef.current = sourceId;
  }, [sourceId]);

  // Update ASAP time based on order type
  useEffect(() => {
    // Calculate ready time based on preparation time, not first available slot
    const calculateReadyTime = () => {
      const now = new Date();
      let preparationMinutes = 15; // default for pickup

      if (orderType === 'delivery' || orderType === 'noDriverDelivery') {
        preparationMinutes = 45; // 45 min for delivery
      } else if (orderType === 'pickup') {
        preparationMinutes = 15; // 15 min for pickup
      }

      // Calculate the ready time by adding preparation minutes to current time
      const readyTime = new Date(now.getTime() + preparationMinutes * 60 * 1000);

      // Format the ready time in user's locale with AM/PM format
      const formattedTime = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        hourCycle: 'h12',
      }).format(readyTime);

      return formattedTime;
    };

    const readyTime = calculateReadyTime();

    if (orderType === 'delivery' || orderType === 'noDriverDelivery') {
      setAsap(`Your order will be delivered approximately within 45 min - 1 hour`);
    } else {
      setAsap(`Your order will be ready to pickup approximately within 15 minutes`);
    }
  }, [orderType]);

  // Saved card functionality states
  const [savedCards, setSavedCards] = useState([]);
  const [selectedSavedCardId, setSelectedSavedCardId] = useState(null);
  const [shouldSaveCard, setShouldSaveCard] = useState(false);
  const [useNewCard, setUseNewCard] = useState(false);

  // Gift card states (now partial payment)
  const [giftCardCode, setGiftCardCode] = useState('');
  const [appliedGiftCard, setAppliedGiftCard] = useState(null); // { code, balance, amountToUse }

  const squarePaymentRef = useRef(null);
  const cashAppPayRef = useRef(null);
  const applePayRef = useRef(null);
  const googlePayRef = useRef(null);
  const [currentRedeemPoints, setCurrentRedeemPoints] = useState(null);
  const [isLoadingPoints, setIsLoadingPoints] = useState(false);
  const isCheckoutProcessingRef = useRef(false); // Prevent duplicate checkout requests

  // Derive cart store ID from bagItems - single source of truth, same as CartDrawer
  const cartStoreId = useMemo(() => {
    if (Array.isArray(user?.bagItems) && user.bagItems.length > 0) {
      return user.bagItems[0]?.storeId ?? user.bagItems[0]?.store_id ?? '';
    }
    return '';
  }, [user?.bagItems]);

  // Personal Info state
  const [personalFirstName, setPersonalFirstName] = useState(
    user?.firstName || ''
  );
  const [personalLastName, setPersonalLastName] = useState(
    user?.lastName || ''
  );
  const [personalEmail, setPersonalEmail] = useState(user?.email || '');
  const [personalPhone, setPersonalPhone] = useState(user?.phoneNumber || '');
  const [personalErrors, setPersonalErrors] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
  });
  const [isCheckingEmail, setIsCheckingEmail] = useState(false);
  // Email auto-fill state
  const [isEmailAutoFilled, setIsEmailAutoFilled] = useState(false);
  const [isEmailLocked, setIsEmailLocked] = useState(false);
  const [registeredPhoneEmail, setRegisteredPhoneEmail] = useState(null); // Store the original phone-email pair
  // Name auto-fill state
  const [isFirstNameAutoFilled, setIsFirstNameAutoFilled] = useState(false);
  const [isLastNameAutoFilled, setIsLastNameAutoFilled] = useState(false);
  const [isNamesLocked, setIsNamesLocked] = useState(false);
  const [registeredPhoneNames, setRegisteredPhoneNames] = useState(null); // Store the original phone-names pair

  // OTP verification state
  const [isPhoneVerification, setIsPhoneVerification] = useState(false);
  const [isSendingOTP, setIsSendingOTP] = useState(false);
  const [OTP, setOTP] = useState('');
  const [verifiedNum, setVerifiedNum] = useState(false);
  const [otpError, setOtpError] = useState('');
  const otpSectionRef = useRef(null);
  const [capturedAnonymousUid, setCapturedAnonymousUid] = useState(null); // Store anonymous UID before conversion
  const migratedAddressIdRef = useRef(null); // Store migrated address ID for use in proceedWithOrder
  const emailCheckTimeoutRef = useRef(null);
  const emailCheckCacheRef = useRef(new Map()); // Cache: { email: { exists: boolean, timestamp: number } }
  const EMAIL_CACHE_TTL = 5 * 60 * 1000; // 5 minutes cache

  // New dialog states for refactored flow
  const [showEmailDialog, setShowEmailDialog] = useState(false);
  const [showPersonalInfoDialog, setShowPersonalInfoDialog] = useState(false);
  const [isUpdatingEmail, setIsUpdatingEmail] = useState(false);
  const [tempEmail, setTempEmail] = useState(''); // Temporary email while editing
  const [tempFirstName, setTempFirstName] = useState(''); // Temporary firstName while editing
  const [tempLastName, setTempLastName] = useState(''); // Temporary lastName while editing
  const [emailDialogError, setEmailDialogError] = useState('');
  const [isExistingUser, setIsExistingUser] = useState(false);
  const [authUserData, setAuthUserData] = useState(null); // Store user data after OTP verification
  const [emailConfirmed, setEmailConfirmed] = useState(false); // Track if email is confirmed
  const [hasEmailChanged, setHasEmailChanged] = useState(false); // Track if email is different from original

  // Tip reset for gift-card-only: Square requires tips to be paid with a payment method, not gift card.
  const [showTipResetForGiftCardDialog, setShowTipResetForGiftCardDialog] =
    useState(false);
  const [shouldProceedAfterTipReset, setShouldProceedAfterTipReset] =
    useState(false);

  // If the authenticated user already has an email, we treat the checkout
  // dialog email as read-only (contact info comes from profile), so we
  // disable editing that field to avoid confusing the user.
  const authHasEmailForDialog = !!(auth?.currentUser && auth.currentUser.email);

  const {
    storeId: storeIdFromState,
    defaultAdd: defaultAddressFromState,
    deliveryId,
    storeAddressDetails,
  } = useLocation().state || {};

  const {
    handleCheckoutAuth,
    handleOrderPlacementAuth,
    isAnonymous,
    syncCartFromFirebase,
    isLoggedIn,
    initializeAnonymousSession,
  } = useAnonymousAuth();

  // Use unified delivery address hook to get the current address from Redux
  const {
    currentDeliveryAddressData,
    currentDeliveryAddressId,
    ensureDeliveryAddressSaved,
  } = useDeliveryAddress();

  // Compute the delivery address display - prefer Redux state, fallback to navigation state
  const effectiveDeliveryAddress = useMemo(() => {
    // First try to get from the unified hook (Redux state)
    if (currentDeliveryAddressData) {
      return (
        currentDeliveryAddressData.displayName ||
        currentDeliveryAddressData.address ||
        ''
      );
    }
    // Fallback to navigation state
    return defaultAddressFromState || '';
  }, [currentDeliveryAddressData, defaultAddressFromState]);

  // Compute effective delivery ID
  const effectiveDeliveryId = useMemo(() => {
    return currentDeliveryAddressId || deliveryId || deliveryAddress || '';
  }, [currentDeliveryAddressId, deliveryId, deliveryAddress]);

  // Ensure we always have an auth context before selecting/saving addresses so we avoid temp_* IDs
  useEffect(() => {
    if (!auth?.currentUser) {
      initializeAnonymousSession(orderType || 'pickup');
    }
    try {
      sessionStorage.setItem('redirectAfterAuth', '/confirmorder');
    } catch (e) {}
  }, [initializeAnonymousSession, orderType]);

  const filteredStore = stores.find(
    (store) => store.id === (storeIdD || user?.defaultStore)
  );

  const [freeItemDetailsData, setFreeItemDetailsData] = useState('');
  const [freeItemId, setFreeItemId] = useState('');
  // Shared function to calculate price with optional parameters (tip changes or reward selections)
  const calculatePriceWithUpdates = async ({
    newTipAmount = null,
    rewardTierId = undefined, // Changed to undefined as default
    loyaltyAccountId: customLoyaltyAccountId = undefined, // Changed to undefined as default
    rewardItemId = null,
    calculateType = 'price',
    giftCardNonce = undefined, // undefined = use appliedGiftCard; null = explicitly no gift card (e.g. on remove)
  } = {}) => {
    try {
      if (!user) {
        return;
      }

      const token = await auth?.currentUser?.getIdToken();
      const headers = {
        'Content-Type': 'application/json',
        Authorization: token,
      };

      // Determine which tip amount to use (stored in cents in state)
      const finalTipAmount = newTipAmount !== null ? newTipAmount : tipAmount;

      // Determine which reward to use
      // If rewardTierId is explicitly passed (including null), use it
      // Otherwise, fall back to selectedOffer
      const finalRewardTierId =
        rewardTierId !== undefined ? rewardTierId : selectedOffer;

      // Same logic for loyalty account ID
      const finalLoyaltyAccountId =
        customLoyaltyAccountId !== undefined
          ? customLoyaltyAccountId
          : loyaltyData?.message?.account?.id;

      const selectedRewardForRequest = finalRewardTierId
        ? programOffers.find((p) => p.id === finalRewardTierId)
        : null;

      // Determine which gift card nonce to use:
      // - undefined (not passed): fall back to appliedGiftCard
      // - null (explicit, e.g. on remove): no gift card, omit from request
      // - string (token): use it
      const finalGiftCardNonce =
        giftCardNonce === undefined
          ? appliedGiftCard?.code || null
          : giftCardNonce;

      // Tip is stored in state in cents.
      // - API expects tip in cents
      // - calculateTotalAmount expects dollars
      const tipAmountInCents =
        typeof finalTipAmount === 'number' ? finalTipAmount : 0;
      const tipAmountInDollars = tipAmountInCents / 100;

      // Calculate total amount (in dollars) using the dollar value
      const totalAmountForPrice = calculateTotalAmount(
        user?.bagItems || [],
        tipAmountInDollars,
        orderType === 'delivery' || orderType === 'noDriverDelivery'
          ? effectiveDeliveryId
          : null
      );

      // Always try to send a uid: prefer Firebase auth uid, then Redux userData uid/id
      const uidForRequest =
        auth?.currentUser?.uid || user?.uid || user?.id || null;

      const requestBody = {
        storeId: storeIdD || storeId || '',
        deliveryOrPickup: orderType || 'pickup',
        totalAmount: totalAmountForPrice,
        restaurantId: environment.restaurantId,
        // IMPORTANT: API expects tip amount in cents
        tipAmount: tipAmountInCents,
        uid: uidForRequest,
        ...(orderType === 'delivery' || orderType === 'noDriverDelivery'
          ? { deliveryId: effectiveDeliveryId }
          : {}),
        // Include gift card nonce if available
        ...(finalGiftCardNonce && { giftCardNonce: finalGiftCardNonce }),
        // Always include reward fields. If user didn't choose a reward, send nulls
        rewardTierId: finalRewardTierId || null,
        loyaltyAccountId: finalLoyaltyAccountId || null,
        // Include rewardItemId (explicit null when not provided)
        ...(rewardItemId && { rewardItemId }),
        // Include freeVariationId only when a rewardItemId is provided and the reward is a free-item (100%)
        ...(rewardItemId &&
          selectedRewardForRequest?.discount?.discountData?.percentage ===
            '100.0' && { freeVariationId: rewardItemId }),
      };

      const response = await fetchData(
        `${environment?.apiUrl}/loyalty/calculatePrice?restaurantId=${environment.restaurantId}`,
        'POST',
        requestBody,
        headers
      );
      if (response) {
        // Flat calculatePrice responses often omit totalWithTip when tip is 0; use order total (cents).
        const totalCents =
          Number(
            response.total ??
              response.data?.total ??
              response.data?.data?.total ??
              response.data?.message?.pricing?.total ??
              0
          ) || 0;

        const totalWithTipCandidates = [
          response.totalWithTip,
          response.data?.totalWithTip,
          response.data?.data?.totalWithTip,
          response.data?.message?.pricing?.totalWithTip,
        ];
        const totalWithTipRaw = totalWithTipCandidates.find(
          (v) => v !== undefined && v !== null && v !== ''
        );
        const normalizedTotalWithTip =
          totalWithTipRaw !== undefined
            ? Number(totalWithTipRaw) || 0
            : totalCents;

        const remainingCandidates = [
          response.remainingAmount,
          response.data?.remainingAmount,
          response.data?.data?.remainingAmount,
          response.data?.message?.pricing?.remainingAmount,
        ];
        const remainingRaw = remainingCandidates.find(
          (v) => v !== undefined && v !== null && v !== ''
        );
        const normalizedRemainingAmount =
          remainingRaw !== undefined
            ? Number(remainingRaw) || 0
            : normalizedTotalWithTip;

        const pricingData = {
          serviceChargeMoney:
            response.serviceChargeMoney ||
            response.data?.serviceChargeMoney ||
            response.data?.message?.pricing?.serviceCharge ||
            '0',
          subtotal:
            response.subtotal ||
            response.data?.subtotal ||
            response.data?.message?.pricing?.subtotal ||
            0,
          tax:
            response.tax ||
            response.data?.tax ||
            response.data?.message?.pricing?.tax ||
            '0',
          tip:
            response.tip ||
            response.data?.tip ||
            response.data?.message?.pricing?.tip ||
            '0',
          total:
            response.total ||
            response.data?.total ||
            response.data?.message?.pricing?.total ||
            0,
          totalWithTip: normalizedTotalWithTip,
          remainingAmount: normalizedRemainingAmount,
          giftCardBalance:
            response.giftCardBalance ||
            response.data?.giftCardBalance ||
            response.data?.message?.pricing?.giftCardBalance ||
            0,
          giftCardDetails:
            response.giftCardDetails ||
            response.data?.giftCardDetails ||
            response.data?.message?.pricing?.giftCardDetails ||
            null,
          total_items: response.total_items || response.data?.total_items || 0,
          total_modifiers:
            response.total_modifiers || response.data?.total_modifiers || 0,
          total_modifiers_price:
            response.total_modifiers_price ||
            response.data?.total_modifiers_price ||
            response.data?.message?.pricing?.totalModifiersPrice ||
            0,
          total_modifiers_price_percentage:
            response.total_modifiers_price_percentage ||
            response.data?.total_modifiers_price_percentage ||
            0,
          total_discounts:
            response.total_discounts || response.data?.total_discounts || 0,
          discount:
            response.discount ||
            response.data?.discount ||
            response.data?.message?.pricing?.discount ||
            0,
          loyaltyDiscount:
            response.loyaltyDiscount ||
            response.data?.loyaltyDiscount ||
            response.data?.message?.loyaltyDiscount ||
            response.data?.message?.pricing?.loyaltyDiscount ||
            0,
          lineItemData:
            response.lineItemsPrice || response.data?.lineItemsPrice || null,
          ...(finalRewardTierId && {
            appliedReward: {
              rewardTierId: finalRewardTierId,
              loyaltyAccountId: finalLoyaltyAccountId,
            },
          }),
          taxes_text:
            response.taxes_text ||
            response.data.taxes_text ||
            response.data?.message?.pricing?.taxes_text ||
            response.data?.message?.pricing?.taxesText ||
            null,
          onlineFee:
            response.onlineFee ||
            response.data.onlineFee ||
            response.data?.message?.pricing?.onlineFee ||
            null,
        };

        // Update Redux store with new pricing data
        const cartData = {
          discount: discount || 0,
          code: code || '',
          isVerify: false,
          typeAddress: typeAddress || '',
          orderType: orderType || 'pickup',
          storeId: storeIdD || storeId || '',
          apiPricingData: pricingData,
          subTotal: pricingData.subtotal,
          backendTotal: pricingData.total,
          backendTax: pricingData.tax,
          backendSubtotal: pricingData.subtotal,
          backendTotalDiscounts: pricingData.total_discounts,
          backendDeliveryFee: pricingData.serviceChargeMoney,
        };

        dispatch(UpdateCartData(cartData));

        return pricingData;
      }
    } catch (error) {
      throw error;
    }
  };

  // This ensures OrderSummary displays the correct tip when cart quantities change
  useEffect(() => {
    if (apiPricingData && typeTip !== 'other') {
      const currentTotal = apiPricingData.total / 100;
      let recalculatedTip = 0;

      if (typeTip === 'a') {
        recalculatedTip = Math.round(((currentTotal * 10) / 100) * 100); // 10% in cents
      } else if (typeTip === 'b') {
        recalculatedTip = Math.round(((currentTotal * 15) / 100) * 100); // 15% in cents
      } else if (typeTip === 'c') {
        recalculatedTip = Math.round(((currentTotal * 20) / 100) * 100); // 20% in cents
      }

      // Only update if the calculated tip differs from current tipAmount
      if (recalculatedTip !== tipAmount && recalculatedTip > 0) {
        setTipsAmount(recalculatedTip);
      }
    }
  }, [apiPricingData, typeTip]); // Only depend on apiPricingData and typeTip, not tipAmount to avoid loops

  // Handler for tip changes
  const handleTipChange = async (newTipAmount) => {
    try {
      setTipsAmount(newTipAmount);
      // Call API with new tip amount to recalculate pricing
      await calculatePriceWithUpdates({ newTipAmount });
    } catch (error) {
      // Error handling
    }
  };

  // Handler for reward selections
  const handleRewardSelection = async (
    rewardTierId,
    loyaltyAccountId,
    selectedItemId = null
  ) => {
    try {
      // Find the selected reward to check its points requirement
      const selectedReward = programOffers.find(
        (offer) => offer.id === rewardTierId
      );

      if (selectedReward && selectedReward.points > currentRedeemPoints) {
        // Show error message - user doesn't have enough points
        // You can add a toast notification or alert here if needed
        return;
      }

      // For free item rewards (100% discount), ensure an item is selected
      if (
        selectedReward?.discount?.discountData?.percentage === '100.0' &&
        !selectedItemId
      ) {
        return;
      }

      // For percentage tips, we need to recalculate based on the new total after reward
      // But we don't know the new total yet, so we'll do a two-step process:
      // 1. First API call to get new total with reward
      // 2. Recalculate tip based on new total
      // 3. Second API call with updated tip

      // Step 1: Get pricing with reward (using current tip)
      const newPricingData = await calculatePriceWithUpdates({
        rewardTierId,
        loyaltyAccountId,
        rewardItemId: selectedItemId,
        calculateType: 'loyalty',
      });

      // Step 2 & 3: Recalculate tip based on new total if percentage tip is selected
      if (newPricingData && typeTip !== 'other') {
        const newTotal = newPricingData.total / 100;
        let newTipAmount = 0;

        // Recalculate based on which percentage is selected
        if (typeTip === 'a') {
          newTipAmount = Math.round(((newTotal * 10) / 100) * 100); // 10% in cents
        } else if (typeTip === 'b') {
          newTipAmount = Math.round(((newTotal * 15) / 100) * 100); // 15% in cents
        } else if (typeTip === 'c') {
          newTipAmount = Math.round(((newTotal * 20) / 100) * 100); // 20% in cents
        }

        // Update tip amount state immediately so TipsBox displays correct values
        setTipsAmount(newTipAmount);

        // Only make another API call if the tip amount actually changed
        if (Math.abs(newTipAmount - tipAmount) > 1) {
          // Call API again with the updated tip to get final pricing
          await calculatePriceWithUpdates({
            newTipAmount,
            rewardTierId,
            loyaltyAccountId,
            rewardItemId: selectedItemId,
          });
        }
      }
    } catch (error) {
      // Error handling
    }
  };

  // Fetch loyalty programs to populate redeem offers
  useEffect(() => {
    const fetchPrograms = async () => {
      try {
        // Don't fetch for anonymous users
        if (isAnonymous) {
          setIsLoadingPoints(false);
          return;
        }

        // Check if user has phone number
        if (!user?.phoneNumber) {
          setIsLoadingPoints(false);
          return;
        }

        // Wait for cart store ID to be available
        if (!cartStoreId) {
          setIsLoadingPoints(false);
          return;
        }

        setIsLoadingPoints(true);
        const token = await auth?.currentUser?.getIdToken();
        const headers = {
          'Content-Type': 'application/json',
          Authorization: token,
        };
        // Remove leading '+' from phone number if present
        const sanitizedPhoneNumber = String(user?.phoneNumber || '').replace(
          /^\+/,
          ''
        );
        const loyaltyProgramId =
          environment.restaurantId === 'fattyPattyDev'
            ? '832fe29b-3700-4977-ad33-be88f6aa9a54'
            : 'a66ddd7b-362d-4fea-ab5b-dd06974aaf21';

        const query = new URLSearchParams({
          phoneNumber: sanitizedPhoneNumber,
          restaurantId: environment.restaurantId,
          programId: loyaltyProgramId,
          customerId: user.uid,
        }).toString();

        const responseRaw = await fetch(
          `${environment.apiUrl}/loyalty/accounts?${query}`,
          {
            method: 'GET',
            headers,
          }
        );
        const res = await responseRaw.json();

        // IMPORTANT: Use cartStoreId from bagItems, not storeIdD
        const currentStoreId = cartStoreId || user?.defaultStore;
        const programLocationIds = res?.message?.program?.locationIds || [];

        // If locationIds array exists and has items, check if current store is included
        const isProgramAvailableForStore =
          !programLocationIds.length || // If empty array, program is available for all stores
          programLocationIds.includes(currentStoreId); // Otherwise check if current store is in the list

        if (!isProgramAvailableForStore) {
          setProgramOffers([]);
          setCurrentRedeemPoints(0);
          setLoyaltyData(null);
          setIsLoadingPoints(false);
          return;
        }

        // Store the full loyalty data
        setLoyaltyData(res);

        // New response shape: { success, program: { rewardTiers: [...] } }
        const tiers = res?.message?.program?.rewardTiers || [];
        const availableRewardIds = res?.message?.availableRewards || [];

        // Filter tiers to only include available rewards
        const availableTiers = Array.isArray(tiers)
          ? tiers.filter((tier) => availableRewardIds.includes(tier.id))
          : [];

        const mappedOffers = availableTiers.map((tier) => ({
          id: tier.id,
          title: tier.name,
          subtitle: '',
          points: tier.points,
          saveText: undefined,
          // Include the full tier data for free item functionality
          discount: tier.discount,
          productDetails: tier.productDetails || [],
          productType: tier.productType,
        }));

        const accountBalance = res?.message?.account?.balance || 0;

        setProgramOffers(mappedOffers);
        setCurrentRedeemPoints(accountBalance);
        setIsLoadingPoints(false);
      } catch (e) {
        setProgramOffers([]);
        setCurrentRedeemPoints(0);
        setIsLoadingPoints(false);
      }
    };

    fetchPrograms();
  }, [
    user?.phoneNumber,
    user?.uid,
    user?.defaultStore,
    cartStoreId,
    isAnonymous,
  ]);

  const getENV = async () => {
    const doc = await RootFirestore.collection('environment')
      .doc(environment.restaurantId)
      .get();
    setEnv(doc.data());
  };

  const getOrders = async () => {
    try {
      let StoreRef = firestore
        .collection('orders')
        .where('uid', '==', auth?.currentUser?.uid)
        .orderBy('created_at', 'desc')
        .limit(50);

      let list = [];
      const allOrderStatusArray = [];
      const ActiveOrderStatusArray = [];

      const StoresList = await StoreRef.get();
      for (let index = 0; index < StoresList.docs.length; index++) {
        let element = StoresList.docs[index].data();
        element.id = StoresList.docs[index].id;
        list.push(element);

        // Push 'order_status' into the array
        allOrderStatusArray.push(element.order_status);

        if (
          ['confirmed', 'new', 'ready_to_pickup'].includes(element.order_status)
        ) {
          ActiveOrderStatusArray.push(element.order_status);
        }
      }

      setData(list);

      setActiveorders(ActiveOrderStatusArray);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const getUser = async () => {
    setStoreId(user?.defaultStore);
  };

  const fetchSavedCards = async () => {
    try {
      if (!auth?.currentUser?.uid) {
        return;
      }

      const cardsSnapshot = await firestore
        .collection('users')
        .doc(auth.currentUser.uid)
        .collection('cards')
        .orderBy('createdAt', 'desc')
        .get();

      const cardsData = [];
      cardsSnapshot.forEach((doc) => {
        const cardData = doc.data();
        // Ensure cardId is set - it might be in the document data or the document ID
        // Square card IDs typically start with 'ccof:' or 'card:'
        const cardId = cardData.cardId || cardData.id || doc.id;
        cardsData.push({
          id: doc.id,
          cardId: cardId, // Ensure cardId field exists for SquarePaymentForm
          ...cardData,
        });
      });

      console.log('💳 [fetchSavedCards] Fetched cards:', {
        count: cardsData.length,
        cards: cardsData.map((c) => ({
          id: c.id,
          cardId: c.cardId,
          last4: c.last4,
          brand: c.brand,
        })),
      });

      setSavedCards(cardsData);

      // Auto-select first card if available, otherwise use new card
      if (cardsData.length > 0) {
        const firstCardId = cardsData[0].cardId || cardsData[0].id;
        setSelectedSavedCardId(firstCardId);
        setUseNewCard(false);
        console.log(
          '💳 [fetchSavedCards] Auto-selected first card:',
          firstCardId
        );
      } else {
        setUseNewCard(true);
        console.log(
          '💳 [fetchSavedCards] No saved cards found, using new card'
        );
      }
    } catch (error) {
      console.error('❌ [fetchSavedCards] Error fetching saved cards:', error);
      setUseNewCard(true); // Default to new card on error
    }
  };

  const getStoreData = async () => {
    if (storeId) {
      const foundStore = stores.find((store) => store.id === storeId);

      if (foundStore) {
        setScheduleOrderEnabled(foundStore?.schedule_order_enabled);
        setStoreData(foundStore);

        // Set timezone information for user display
        if (foundStore?.timezone) {
          const tzInfo = getTimezoneDisplayInfo(foundStore.timezone);
          setTimezoneInfo(tzInfo);
        }
      }
    }
  };

  // New function to calculate available times based on StoreData timing
  const calculateAvailableTimesFromStoreData = (storeData) => {
    // Get user's timezone for debugging
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    if (!storeData || !storeData.timing || !Array.isArray(storeData.timing)) {
      return { asap: false, today: [], tomorrow: [], afterTomorrow: [] };
    }

    const timezone = storeData.timezone || 'Etc/UTC';

    // Get current date and time in both store and user timezones
    const now = new Date();

    // Current time in store timezone
    const storeCurrentTime = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).format(now);

    // Current time in user timezone
    const userCurrentTime = new Intl.DateTimeFormat('en-US', {
      timeZone: userTimezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).format(now);

    const currentDay = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      weekday: 'short',
    })
      .format(now)
      .toUpperCase();

    // ===== Item/category availability constraints (based on cart) =====
    // If any items in the cart belong to categories with availability_periods
    // (either on the category itself OR its rootCategory), we will restrict
    // time slots so they don't exceed those periods.
    const cartItems =
      (reduxCart && reduxCart.length ? reduxCart : user?.bagItems) || [];

    const cartCategoryIds = new Set();
    cartItems.forEach((item) => {
      // Support multiple possible shapes from different flows
      if (item?.categoryId) cartCategoryIds.add(item.categoryId);
      if (item?.category_id) cartCategoryIds.add(item.category_id);
      if (Array.isArray(item?.category_ids)) {
        item.category_ids.forEach((cid) => cid && cartCategoryIds.add(cid));
      }
      // Prefer explicit root/menu category id when present (e.g. FattyPatty flow)
      if (item?.availabilityRootCategoryId) {
        cartCategoryIds.add(item.availabilityRootCategoryId);
      }
    });

    // Helper to get effective availability periods for a category:
    // - use its own periods if present
    // - otherwise, if it has a rootCategory, use that root's periods
    const getEffectiveAvailabilityPeriodsForCategory = (cat) => {
      let periods = cat.availability_periods || cat.availabilityPeriods || [];
      if ((!periods || periods.length === 0) && cat.rootCategory) {
        const rootCategoryObj = (categories || []).find(
          (c) => c.id === cat.rootCategory
        );
        if (rootCategoryObj) {
          periods =
            rootCategoryObj.availability_periods ||
            rootCategoryObj.availabilityPeriods ||
            [];
        }
      }
      return periods || [];
    };

    const categoriesWithAvailability =
      (categories || []).filter((cat) => {
        if (!cartCategoryIds.has(cat.id)) return false;
        const periods = getEffectiveAvailabilityPeriodsForCategory(cat);
        return Array.isArray(periods) && periods.length > 0;
      }) || [];

    // Update flag so UI can show a note when item/category constraints
    // are affecting available time slots.
    const hasConstraints =
      Array.isArray(categoriesWithAvailability) &&
      categoriesWithAvailability.length > 0;

    setHasItemAvailabilityConstraints(hasConstraints);

    if (hasConstraints) {
      const names = categoriesWithAvailability
        .map((cat) => cat?.displayName || cat?.name || cat?.title || cat?.label)
        .filter(Boolean);
      setAvailabilityCategoryNames(names);
      lastAvailabilityCategoryNamesRef.current = names;
    } else {
      setAvailabilityCategoryNames([]);
    }

    const timeToMinutes = (timeStr) => {
      if (!timeStr) return 0;
      const [h, m] = timeStr.split(':').map((s) => parseInt(s || '0', 10));
      return (h || 0) * 60 + (m || 0);
    };

    const isSlotAllowedForCart = (dayOfWeek, hhmm) => {
      if (!categoriesWithAvailability.length) return true;
      const slotMinutes = timeToMinutes(hhmm);

      return categoriesWithAvailability.every((category) => {
        const basePeriods =
          getEffectiveAvailabilityPeriodsForCategory(category);
        const activePeriods = basePeriods.filter(
          (p) => !p.isDeleted && p.type === 'AVAILABILITY_PERIOD'
        );
        if (!activePeriods.length) return true;

        return activePeriods.some((period) => {
          const availabilityData = period.availabilityPeriodData;
          if (!availabilityData) return false;

          const {
            dayOfWeek: periodDay,
            startLocalTime,
            endLocalTime,
          } = availabilityData;

          if (!periodDay || !startLocalTime || !endLocalTime) return false;

          // Check correct day
          if (periodDay.toUpperCase() !== dayOfWeek) return false;

          const startM = timeToMinutes(startLocalTime);
          const endM = timeToMinutes(endLocalTime);

          const spansMidnight = endM < startM;
          if (spansMidnight) {
            // Window crosses midnight
            return slotMinutes >= startM || slotMinutes <= endM;
          }

          return slotMinutes >= startM && slotMinutes <= endM;
        });
      });
    };

    // Find today's timing - filter for all entries to handle overflow
    const todayTimings = storeData.timing.filter(
      (t) => t.dayOfWeek === currentDay
    );

    // Helper to parse time to minutes
    const parseMinutes = (hhmmss) => {
      const [h, m] = (hhmmss || '')
        .split(':')
        .map((s) => parseInt(s || '0', 10));
      return (h || 0) * 60 + (m || 0);
    };

    // Separate overflow entry (starts at 00:00) from main entry
    const todayOverflow = todayTimings.find(
      (t) => t.startLocalTime && parseMinutes(t.startLocalTime) === 0
    );
    const todayMain = todayTimings.find(
      (t) => t.startLocalTime && parseMinutes(t.startLocalTime) > 0
    );

    // Use main entry if available, otherwise use first entry
    const todayTiming = todayMain || todayTimings[0];

    // Calculate ASAP availability
    let asapAvailable = false;
    if (todayTiming && todayTiming.startLocalTime && todayTiming.endLocalTime) {
      const currentTime = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      }).format(now);

      // Compare times (HH:MM:SS format)
      // Normalize time formats for proper comparison
      const normalizeTime = (timeStr) => {
        const parts = timeStr.split(':');
        return `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}:${
          parts[2] ? parts[2].padStart(2, '0') : '00'
        }`;
      };

      const normalizedCurrentTime = normalizeTime(currentTime);
      const normalizedStartTime = normalizeTime(todayTiming.startLocalTime);
      const normalizedEndTime = normalizeTime(todayTiming.endLocalTime);
      asapAvailable =
        normalizedCurrentTime >= normalizedStartTime &&
        normalizedCurrentTime <= normalizedEndTime;

      // Additionally, ensure that at least one cart item is available during ASAP time
      if (asapAvailable) {
        const hhmm = normalizedCurrentTime.slice(0, 5); // HH:MM
        if (!isSlotAllowedForCart(currentDay, hhmm)) {
          asapAvailable = false;
        }
      }
      // Show converted store hours for user understanding
      if (timezone !== userTimezone) {
        const storeStartInUserTz = convertStoreTimeToUserLocal(
          todayTiming.startLocalTime,
          timezone
        );
        const storeEndInUserTz = convertStoreTimeToUserLocal(
          todayTiming.endLocalTime,
          timezone
        );
      }
    }

    // Generate time slots for today based on order type
    const todaySlots = [];
    if (todayTiming && todayTiming.startLocalTime && todayTiming.endLocalTime) {
      const [startHour, startMinute] = todayTiming.startLocalTime
        .split(':')
        .map(Number);
      let [endHour, endMinute] = todayTiming.endLocalTime
        .split(':')
        .map(Number);

      // Check if today extends into tomorrow (ends at 24:00)
      // If so, look for tomorrow's overflow entry
      const dayOrder = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
      const todayIndex = dayOrder.indexOf(currentDay);
      const tomorrowKey = dayOrder[(todayIndex + 1) % 7];
      const tomorrowTimings = storeData.timing.filter(
        (t) => t.dayOfWeek === tomorrowKey
      );
      const tomorrowOverflow = tomorrowTimings.find(
        (t) => t.startLocalTime && parseMinutes(t.startLocalTime) === 0
      );

      // If today ends at 24:00 and tomorrow has overflow, extend the end time
      if (
        endHour === 24 &&
        endMinute === 0 &&
        tomorrowOverflow &&
        tomorrowOverflow.endLocalTime
      ) {
        const [overflowEndHour, overflowEndMinute] =
          tomorrowOverflow.endLocalTime.split(':').map(Number);
        // Add 24 hours to represent time after midnight
        endHour = 24 + overflowEndHour;
        endMinute = overflowEndMinute;
      }

      const currentTime = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone,
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }).format(now);

      const [currentHour, currentMinutes] = currentTime.split(':').map(Number);

      // Convert times to minutes for easier calculation
      const startTimeInMinutes = startHour * 60 + startMinute;
      const endTimeInMinutes = endHour * 60 + endMinute - 15; // End 15 minutes before closing
      const currentTimeInMinutes = currentHour * 60 + currentMinutes;

      // Slot spacing: every 15 minutes (00, 15, 30, 45) for all order types
      const intervalMinutes = 15;
      const preparationTimeMinutes = 15;

      // Start from the later of: (store opening + prep time) OR (current time + prep time)
      const earliestStartTimeRaw = Math.max(
        startTimeInMinutes + preparationTimeMinutes,
        currentTimeInMinutes + preparationTimeMinutes
      );

      // Snap the first slot to the next interval boundary.
      // Examples (pickup, 15-min intervals):
      //  - 3:12 -> 3:15
      //  - 4:22 -> 4:30
      const roundUpToInterval = (minutes, interval) =>
        Math.ceil(minutes / interval) * interval;

      const firstSlotTime = roundUpToInterval(
        earliestStartTimeRaw,
        intervalMinutes
      );

      // Generate slots at specified intervals until 15 minutes before closing
      for (
        let timeInMinutes = firstSlotTime;
        timeInMinutes <= endTimeInMinutes;
        timeInMinutes += intervalMinutes
      ) {
        let slotStartHour = Math.floor(timeInMinutes / 60);
        const slotStartMinute = timeInMinutes % 60;

        // Normalize hours >= 24 to 0-23 range (for times after midnight)
        slotStartHour = slotStartHour % 24;

        const startTime = `${slotStartHour
          .toString()
          .padStart(2, '0')}:${slotStartMinute.toString().padStart(2, '0')}`;

        // Create time slot (single time, not range)
        const storeTimeSlot = startTime;

        // Respect item/category availability constraints for today
        if (!isSlotAllowedForCart(currentDay, storeTimeSlot)) {
          continue;
        }

        // Convert to user's local timezone with AM/PM format for display
        const userTimeSlot = formatTimeSlotForUser(storeTimeSlot, timezone);

        todaySlots.push(userTimeSlot);
      }

      // Remove the first slot as it's always showing store opening time incorrectly
      // if (todaySlots.length > 0) {
      //   todaySlots.shift(); // Remove first element
      // }
    }

    // For tomorrow and after tomorrow, we'll use the same timing if available
    // In a real implementation, you'd want to get the actual next days' timing
    const tomorrowSlots = [];
    const afterTomorrowSlots = [];

    // Find tomorrow's timing (simplified - you might want to implement proper day calculation)
    const tomorrowDay = new Date(now);
    tomorrowDay.setDate(tomorrowDay.getDate() + 1);
    const tomorrowDayName = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      weekday: 'short',
    })
      .format(tomorrowDay)
      .toUpperCase();

    // Filter all timing entries for tomorrow
    const tomorrowTimings = storeData.timing.filter(
      (t) => t.dayOfWeek === tomorrowDayName
    );

    // Separate overflow entries (starting at 00:00:00, from today) from main entries
    const tomorrowOverflow = tomorrowTimings.find(
      (t) => t.startLocalTime && parseMinutes(t.startLocalTime) === 0
    );
    const tomorrowMain = tomorrowTimings.find(
      (t) => t.startLocalTime && parseMinutes(t.startLocalTime) > 0
    );

    // Use the main entry for tomorrow (not overflow from today)
    const tomorrowTiming = tomorrowMain || tomorrowTimings[0];

    if (
      tomorrowTiming &&
      tomorrowTiming.startLocalTime &&
      tomorrowTiming.endLocalTime
    ) {
      let [startHour, startMinute] = tomorrowTiming.startLocalTime
        .split(':')
        .map(Number);
      let [endHour, endMinute] = tomorrowTiming.endLocalTime
        .split(':')
        .map(Number);

      // Check if tomorrow extends into the day after (ends at 24:00)
      const dayOrder = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
      const tomorrowIndex = dayOrder.indexOf(tomorrowDayName);
      const dayAfterKey = dayOrder[(tomorrowIndex + 1) % 7];
      const dayAfterTimings = storeData.timing.filter(
        (t) => t.dayOfWeek === dayAfterKey
      );
      const dayAfterOverflow = dayAfterTimings.find(
        (t) => t.startLocalTime && parseMinutes(t.startLocalTime) === 0
      );

      // If tomorrow ends at 24:00 and day after has overflow, extend the end time
      if (
        endHour === 24 &&
        endMinute === 0 &&
        dayAfterOverflow &&
        dayAfterOverflow.endLocalTime
      ) {
        const [overflowEndHour, overflowEndMinute] =
          dayAfterOverflow.endLocalTime.split(':').map(Number);
        // Add 24 hours to represent time after midnight
        endHour = 24 + overflowEndHour;
        endMinute = overflowEndMinute;
      }

      // Convert times to minutes for easier calculation
      const startTimeInMinutes = startHour * 60 + startMinute;
      const endTimeInMinutes = endHour * 60 + endMinute - 15; // End 15 minutes before closing

      // Slot spacing: every 15 minutes for all order types
      const intervalMinutes = 15;
      const preparationTimeMinutes = 15;

      // For tomorrow, first slot is opening + prep, rounded up to interval
      const earliestTomorrowStart = startTimeInMinutes + preparationTimeMinutes;
      const roundUpToInterval = (minutes, interval) =>
        Math.ceil(minutes / interval) * interval;
      const firstTomorrowSlotTime = roundUpToInterval(
        earliestTomorrowStart,
        intervalMinutes
      );

      // Generate slots at specified intervals until 15 minutes before closing
      for (
        let timeInMinutes = firstTomorrowSlotTime;
        timeInMinutes <= endTimeInMinutes;
        timeInMinutes += intervalMinutes
      ) {
        let slotStartHour = Math.floor(timeInMinutes / 60);
        const slotStartMinute = timeInMinutes % 60;

        // Normalize hours >= 24 to 0-23 range (for times after midnight)
        slotStartHour = slotStartHour % 24;

        const startTime = `${slotStartHour
          .toString()
          .padStart(2, '0')}:${slotStartMinute.toString().padStart(2, '0')}`;

        // Create time slot (single time, not range)
        const storeTimeSlot = startTime;

        // Respect item/category availability constraints for tomorrow
        if (!isSlotAllowedForCart(tomorrowDayName, storeTimeSlot)) {
          continue;
        }

        // Convert to user's local timezone with AM/PM format for display
        const userTimeSlot = formatTimeSlotForUser(storeTimeSlot, timezone);

        tomorrowSlots.push(userTimeSlot);
      }
    }

    // After tomorrow
    const afterTomorrowDay = new Date(now);
    afterTomorrowDay.setDate(afterTomorrowDay.getDate() + 2);
    const afterTomorrowDayName = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      weekday: 'short',
    })
      .format(afterTomorrowDay)
      .toUpperCase();

    const afterTomorrowTiming = storeData.timing.find(
      (t) => t.dayOfWeek === afterTomorrowDayName
    );

    if (
      afterTomorrowTiming &&
      afterTomorrowTiming.startLocalTime &&
      afterTomorrowTiming.endLocalTime
    ) {
      const [startHour, startMinute] = afterTomorrowTiming.startLocalTime
        .split(':')
        .map(Number);
      const [endHour, endMinute] = afterTomorrowTiming.endLocalTime
        .split(':')
        .map(Number);

      // Convert times to minutes for easier calculation
      const startTimeInMinutes = startHour * 60 + startMinute;
      const endTimeInMinutes = endHour * 60 + endMinute - 15; // End 15 minutes before closing

      // Slot spacing: every 15 minutes for all order types
      const intervalMinutes = 15;
      const preparationTimeMinutes = 15;

      // For after tomorrow, first slot is opening + prep, rounded up to interval
      const earliestAfterTomorrow = startTimeInMinutes + preparationTimeMinutes;
      const roundUpToInterval = (minutes, interval) =>
        Math.ceil(minutes / interval) * interval;
      const firstAfterTomorrowSlotTime = roundUpToInterval(
        earliestAfterTomorrow,
        intervalMinutes
      );

      // Generate slots at specified intervals until 15 minutes before closing
      for (
        let timeInMinutes = firstAfterTomorrowSlotTime;
        timeInMinutes <= endTimeInMinutes;
        timeInMinutes += intervalMinutes
      ) {
        const slotStartHour = Math.floor(timeInMinutes / 60);
        const slotStartMinute = timeInMinutes % 60;

        const startTime = `${slotStartHour
          .toString()
          .padStart(2, '0')}:${slotStartMinute.toString().padStart(2, '0')}`;

        // Create time slot (single time, not range)
        const storeTimeSlot = startTime;

        // Respect item/category availability constraints for after tomorrow
        if (!isSlotAllowedForCart(afterTomorrowDayName, storeTimeSlot)) {
          continue;
        }

        // Convert to user's local timezone with AM/PM format for display
        const userTimeSlot = formatTimeSlotForUser(storeTimeSlot, timezone);

        afterTomorrowSlots.push(userTimeSlot);
      }
    }

    const result = {
      asap: asapAvailable,
      today: todaySlots,
      tomorrow: tomorrowSlots,
      afterTomorrow: afterTomorrowSlots,
    };
    return result;
  };

  const onConfirm = async (
    preTokenizedGooglePayToken = null,
    billingData = null
  ) => {
    console.log('🚀 [onConfirm] START - Order confirmation initiated');
    console.log('🚀 [onConfirm] isAnonymous:', isAnonymous);
    console.log('🚀 [onConfirm] verifiedNum:', verifiedNum);
    console.log('🚀 [onConfirm] emailConfirmed:', emailConfirmed);
    console.log('🚀 [onConfirm] personalEmail:', personalEmail);
    console.log('🚀 [onConfirm] personalFirstName:', personalFirstName);
    console.log('🚀 [onConfirm] personalLastName:', personalLastName);
    console.log('🚀 [onConfirm] authUserData:', authUserData);
    console.log('🚀 [onConfirm] user from Redux:', user);

    // Prevent duplicate checkout requests
    if (isCheckoutProcessingRef.current) {
      console.log('⚠️ [onConfirm] BLOCKED - Already processing checkout');
      return;
    }

    isCheckoutProcessingRef.current = true;
    closeConfirmDialog();
    setLoading(true);
    setErr('');

    // No profile/address writes: user data (email, name) and delivery address are already saved.
    // Block anonymous; only getIdToken, clear bagItems, and refresh user run (Firebase).
    if (isAnonymous) {
      setErr('Please sign in to place an order');
      isCheckoutProcessingRef.current = false;
      setLoading(false);
      return;
    }

    // Use ref value if state is not yet updated (for immediate calls after tokenization)
    const currentPaymentMethod = paymentMethod || paymentMethodRef.current;
    const currentSourceId = sourceId !== null ? sourceId : sourceIdRef.current;
    // When the payment dialog calls onConfirm(token, billingData), the first param is the
    // freshly tokenized nonce. Prefer it over state/ref to avoid sending a stale nonce
    // (e.g. from a previous Google Pay or card tokenization).
    const sourceIdFromDialog =
      typeof preTokenizedGooglePayToken === 'string' &&
      preTokenizedGooglePayToken.trim()
        ? preTokenizedGooglePayToken.trim()
        : null;
    const effectiveSourceId = sourceIdFromDialog || currentSourceId;

    console.log(
      '💳 [onConfirm] Validating payment method:',
      currentPaymentMethod,
      {
        fromState: paymentMethod,
        fromRef: paymentMethodRef.current,
      }
    );

    try {
      // Check if this is a gift card only payment (no additional payment method needed)
      const isGiftCardOnly =
        appliedGiftCard && apiPricingData?.remainingAmount <= 0;

      // Validate tip amount for gift card only payments (MUST be 0)
      // Square requires tips to be paid with a payment method, not gift card. Show dialog to confirm resetting tip to 0.
      if (isGiftCardOnly && tipAmount > 0) {
        console.log(
          '❌ [onConfirm] Tips cannot be paid with gift card only — showing tip-reset confirmation dialog'
        );
        isCheckoutProcessingRef.current = false;
        setLoading(false);
        setShowTipResetForGiftCardDialog(true);
        return;
      }

      // Validate payment method selection (skip if gift card only)
      if (!isGiftCardOnly && !currentPaymentMethod) {
        console.log('❌ [onConfirm] No payment method selected');
        setErr('Please select a payment method');
        setLoading(false);
        return;
      }

      let finalSourceId = effectiveSourceId;
      let paymentDataPayload = {};

      // Handle CARD payment (skip if gift card only)
      if (!isGiftCardOnly && currentPaymentMethod === 'CARD') {
        // If using saved card, set sourceId to empty string
        if (selectedSavedCardId && !useNewCard) {
          finalSourceId = '';
          paymentDataPayload = {
            type: 'CARD',
            savedCardId: selectedSavedCardId,
          };
        } else {
          // New card: tokenization already happened in PaymentMethodDialog.
          // Use effectiveSourceId (prefers nonce passed from dialog over state/ref).
          if (!effectiveSourceId) {
            setErr('Please enter valid card details');
            isCheckoutProcessingRef.current = false;
            setLoading(false);
            return;
          }

          finalSourceId = effectiveSourceId;
          paymentDataPayload = {
            type: 'CARD',
            sourceId: finalSourceId,
          };
        }
      }
      // Handle CASH_APP payment (skip if gift card only)
      else if (!isGiftCardOnly && currentPaymentMethod === 'CASH_APP') {
        if (!effectiveSourceId) {
          console.log('❌ [onConfirm] Cash App not authorized yet');
          setErr('Please scan the QR code with Cash App to authorize payment');
          isCheckoutProcessingRef.current = false;
          setLoading(false);
          return;
        }

        console.log('💳 [onConfirm] Using Cash App token');
        finalSourceId = effectiveSourceId;

        paymentDataPayload = {
          type: 'CASH_APP',
          sourceId: finalSourceId,
        };
      }
      // Handle APPLE_PAY payment (skip if gift card only)
      else if (!isGiftCardOnly && currentPaymentMethod === 'APPLE_PAY') {
        if (!effectiveSourceId) {
          setErr('Please complete Apple Pay authorization');
          isCheckoutProcessingRef.current = false;
          setLoading(false);
          return;
        }

        finalSourceId = effectiveSourceId;
        paymentDataPayload = {
          type: 'APPLE_PAY',
          sourceId: finalSourceId,
        };
      }
      // Handle GOOGLE_PAY payment (skip if gift card only)
      else if (!isGiftCardOnly && currentPaymentMethod === 'GOOGLE_PAY') {
        if (!effectiveSourceId) {
          setErr('Please complete Google Pay authorization');
          setLoading(false);
          return;
        }
        if (sourceIdFromDialog) {
          console.log('💳 [onConfirm] Using token from dialog (Google Pay)');
        }
        finalSourceId = effectiveSourceId;

        paymentDataPayload = {
          type: 'GOOGLE_PAY',
          sourceId: finalSourceId,
        };
      }

      const types = { googlePay: 'google_pay', applePay: 'apple_pay' };
      const type = +change !== NaN ? 'card' : types[change];
      const deliveryOrPickup =
        orderType === 'delivery' ? 'delivery' : orderType || 'pickup';
      const storeId = storeIdD || user?.defaultStore;
      const billingZipcode = userCard?.address_zip ? userCard?.address_zip : '';
      const cartItems = user?.bagItems;
      const phoneNumber = user?.phoneNumber;
      const classroom = classroomNumber;
      //note

      const deliveryIdForOrder = effectiveDeliveryId;

      // if (orderType != 'dinein') {
      //   if (change == 'newCard' || !selectedValue) {
      //     setErr('test 111');
      //     setLoading(false);
      //     return;
      //   }
      // }

      let dateOrderScheduling;
      let isScheduling;

      if (orderType === 'dinein') {
        dateOrderScheduling = null;
        isScheduling = false;
        if (change == 'newCard') {
          setErr(t('confirmPage.pleaseChooseCard'));
          setLoading(false);
          return;
        }
      }

      if (orderType !== 'dinein') {
        isScheduling = selectedValue !== 'a';
        dateOrderScheduling = dateOfOrder;
        if (!dateOrderScheduling && isScheduling) {
          setErr(t('confirmPage.pleaseChooseDate'));
          setLoading(false);
          return;
        }
      }

      auth?.currentUser.getIdToken().then(async (token) => {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: token,
        };

        // Delivery address is already saved; use it as-is (no Firebase address/ensure calls).
        const finalDeliveryIdForOrder = deliveryIdForOrder;

        const transformedCartItems = cartItems.map((item) => ({
          itemId: item.itemId,
          variationId: item.variationId || item.itemId,
          variationName: item.variationName || '',
          customization: transformCustomization(item.customization),
          quantity: item.quantity,
          calculatedPrice: item.calculatedPrice,
        }));

        // If a free-item reward was selected, append the free variation to the cart items
        // so the backend receives both the user's items and the complimentary item.
        if (selectedRewardItemId && freeItemDetailsData && freeItemId) {
          try {
            const freeItemEntry = {
              itemId:
                freeItemId ||
                freeItemDetailsData.id ||
                freeItemDetailsData.itemId ||
                '',
              variationId: selectedRewardItemId,
              variationName:
                freeItemDetailsData.variationName ||
                freeItemDetailsData.name ||
                '',
              customization: transformCustomization([]),
              quantity: 1,
              calculatedPrice: 0,
            };
            transformedCartItems.push(freeItemEntry);
          } catch (err) {
            // Error handling
          }
        }

        const transformedPayload = {
          uid: auth?.currentUser?.uid,
          cartItems: transformedCartItems,
          deliveryOrPickup: deliveryOrPickup || 'pickup',
          // Only include deliveryId for delivery orders
          ...(deliveryOrPickup === 'delivery' ||
          deliveryOrPickup === 'noDriverDelivery'
            ? { deliveryId: finalDeliveryIdForOrder }
            : {}),
          isScheduling: isScheduling,
          dateOrderScheduling: dateOrderScheduling,
          storeId: storeId,
          totalAmount: apiPricingData?.total,
          type: type,
          tipAmount: tipAmount,
          note: note,
          // If gift card is applied, use paymentMethods array; otherwise use paymentData
          ...(appliedGiftCard
            ? {
                paymentMethods: isGiftCardOnly
                  ? [
                      {
                        type: 'GIFT_CARD',
                        sourceId: appliedGiftCard.code,
                        code: appliedGiftCard.code,
                      },
                    ]
                  : [
                      {
                        type: 'GIFT_CARD',
                        sourceId: appliedGiftCard.code,
                        code: appliedGiftCard.code,
                      },
                      // For gift card + saved card, use savedCardId in array
                      // For gift card + new card, use paymentDataPayload
                      selectedSavedCardId && !useNewCard
                        ? {
                            type: 'CARD',
                            savedCardId: selectedSavedCardId,
                          }
                        : paymentDataPayload,
                    ],
                // For gift card + new card, also include paymentData at root for billing
                ...(selectedSavedCardId && !useNewCard
                  ? {}
                  : {
                      paymentData: {
                        sourceId: paymentDataPayload.sourceId,
                        type: paymentDataPayload.type,
                      },
                    }),
              }
            : selectedSavedCardId && !useNewCard
            ? {
                // Saved Card Only: Use savedCardId at root level
                savedCardId: selectedSavedCardId,
              }
            : {
                // New Card Only or Wallet: Use paymentData (sourceId and type only).
                paymentData: {
                  sourceId: paymentDataPayload.sourceId,
                  type: paymentDataPayload.type,
                },
              }),

          // Add saved card properties (only for new cards, not saved cards)
          saveCard: shouldSaveCard && useNewCard ? true : false,
          savedCardId:
            selectedSavedCardId && !useNewCard ? selectedSavedCardId : null,

          // Only include serviceChargeMoney for delivery orders
          ...(deliveryOrPickup === 'delivery' ||
          deliveryOrPickup === 'noDriverDelivery'
            ? { serviceChargeMoney: apiPricingData?.serviceChargeMoney || 0 }
            : {}),
          ...(selectedOffer
            ? {
                useLoyalty: true,
                programId:
                  environment.restaurantId === 'fattyPattyDev'
                    ? '832fe29b-3700-4977-ad33-be88f6aa9a54'
                    : 'a66ddd7b-362d-4fea-ab5b-dd06974aaf21',
                rewardTierId: selectedOffer,
                // Include rewardItemId for free item rewards and also send freeVariationId
                ...(selectedRewardItemId && {
                  rewardItemId: selectedRewardItemId,
                }),
              }
            : {}),
        };

        await fetchData(
          `${environment?.apiUrl}/${
            environment.restaurantId === 'fattyPattyDev' ||
            environment.restaurantId === 'fattyPatty'
              ? 'checkoutSquareCash'
              : 'checkoutCloverLive'
          }?restaurantId=${environment.restaurantId}`,
          'post',
          transformedPayload,
          headers
        )
          .then(async (c) => {
            // Check if response contains an error code/message (even if HTTP status is 200)
            if (c?.data?.code && c?.data?.code !== 'success') {
              throw new Error(
                c?.data?.message ||
                  c?.data?.error ||
                  c?.data?.err ||
                  'Order failed'
              );
            }

            if (c?.data?.error && c?.data?.success !== true) {
              throw new Error(
                c?.data?.message || c?.data?.error || 'Order failed'
              );
            }

            // Check if response data indicates success
            if (c?.data?.success === true || c?.data?.success === 'true') {
              try {
                await firestore
                  .collection('users')
                  .doc(auth?.currentUser?.uid)
                  .set(
                    {
                      bagItems: [],
                    },
                    { merge: true }
                  );
                dispatch(setCart([]));
                // Sync Redux user: we only merged bagItems:[] in Firestore, so set user.bagItems=[] locally (avoids a Firestore read)
                dispatch(
                  setUser({
                    userData: {
                      ...(user || {}),
                      bagItems: [],
                      uid: auth?.currentUser?.uid,
                    },
                  })
                );
                dispatch(UdpateNote(''));
                dispatch(UpdateCartData({ ...cartData, scheduledTime: null }));
                dispatch(UpdateScheduledTime(null));

                // Reset payment token to force new tokenization for next order

                isCheckoutProcessingRef.current = false;
                setLoading(false);
                navigate('/order-success');
              } catch (cleanupError) {
                dispatch(UpdateScheduledTime(null));
                isCheckoutProcessingRef.current = false;
                setLoading(false);
                // Still navigate even if cleanup fails
                navigate('/order-success');
              }
            } else {
              // Handle unsuccessful response
              throw new Error(c?.data?.message || 'Order failed');
            }
          })
          .catch(async (e) => {
            // Check if error response actually contains success
            if (
              e.response?.data?.success === true ||
              e.response?.data?.success === 'true'
            ) {
              // This is actually a successful order, proceed with success flow
              try {
                await firestore
                  .collection('users')
                  .doc(auth?.currentUser?.uid)
                  .set(
                    {
                      bagItems: [],
                    },
                    { merge: true }
                  );
                dispatch(setCart([]));
                // Sync Redux user: we only merged bagItems:[] in Firestore, so set user.bagItems=[] locally (avoids a Firestore read)
                dispatch(
                  setUser({
                    userData: {
                      ...(user || {}),
                      bagItems: [],
                      uid: auth?.currentUser?.uid,
                    },
                  })
                );
                dispatch(UdpateNote(''));
                dispatch(UpdateCartData({ ...cartData, scheduledTime: null }));
                dispatch(UpdateScheduledTime(null));

                // Reset payment token to force new tokenization for next order
                // setSourceId(null);

                isCheckoutProcessingRef.current = false;
                setLoading(false);
                navigate('/order-success');
              } catch (firestoreError) {
                dispatch(UpdateScheduledTime(null));
                isCheckoutProcessingRef.current = false;
                setLoading(false);
                // Still navigate even if cleanup fails
                navigate('/order-success');
              }
              return;
            }

            // Extract error message from various possible locations
            let errorMessage =
              e.response?.data?.message ||
              e.response?.data?.shortMessage ||
              e.response?.data?.err ||
              e.response?.data?.error ||
              (typeof e.response?.data === 'string'
                ? e.response?.data
                : null) ||
              e.message ||
              'Something went wrong';

            // Remove "Request failed with status code XXX" prefix from Axios errors
            errorMessage = errorMessage.replace(
              /^Request failed with status code \d+\.?\s*/i,
              ''
            );

            // If there are details in the error response, append them
            if (
              e.response?.data?.details &&
              Array.isArray(e.response.data.details)
            ) {
              const detailMessages = e.response.data.details
                .map((detail, index) => {
                  if (typeof detail === 'string') return detail;
                  if (detail.error) return detail.error;
                  if (detail.message) return detail.message;
                  if (detail.fieldId && detail.error)
                    return `${detail.fieldId}: ${detail.error}`;
                  return null;
                })
                .filter(Boolean);

              if (detailMessages.length > 0) {
                errorMessage = `${errorMessage}. ${detailMessages.join('. ')}`;
              }
            }

            // Ensure we don't show an empty message
            if (!errorMessage || errorMessage.trim() === '') {
              errorMessage = 'Something went wrong';
            }

            if (e.response?.data?.message?.includes('catering')) {
              handleToaster('error', t('confirmPage.cantCreateCatering'));
            } else if (
              errorMessage.includes('delivery_address_not_found') ||
              errorMessage.includes('Delivery address not found')
            ) {
              handleToaster(
                'error',
                'Please add a delivery address before placing your order.'
              );
              setErr(
                'Please add a delivery address before placing your order.'
              );
            } else {
              handleToaster('error', errorMessage);
              setErr(errorMessage);
            }
            isCheckoutProcessingRef.current = false;
            setLoading(false);
          });
      });
    } catch (e) {
      isCheckoutProcessingRef.current = false;
      setLoading(false);
      setErr(
        e.response?.data?.message ||
          t('confirmPage.somethingWrongTryAgainLater')
      );
    }
  };

  // After user confirms tip reset for gift-card-only: recalc has run, tip is 0 — proceed with onConfirm.
  useEffect(() => {
    if (shouldProceedAfterTipReset && tipAmount === 0) {
      console.log(
        '✅ [TipResetEffect] Tip reset confirmed. Proceeding with onConfirm...',
        { shouldProceedAfterTipReset, tipAmount }
      );
      setShouldProceedAfterTipReset(false);
      onConfirm();
    } else if (shouldProceedAfterTipReset) {
      console.log(
        '⚠️ [TipResetEffect] Waiting for tipAmount to become 0 before proceeding',
        { shouldProceedAfterTipReset, tipAmount }
      );
    }
  }, [shouldProceedAfterTipReset, tipAmount]);

  const onSelect = (value, cart = null) => {
    setUserCard(cart);
    setChange(value);
    switch (value) {
      case 'newCard':
        setOpenCredit(true);
        setD(true);
        return;
      case '0' || '1' || '2' || '3' || '5' || '6' || '7':
        setUserCard(cart);
        setD(false);
        return;
      case 'googlePay':
        // Google Pay functionality removed
        setD(false);
        return;
      case 'applePay':
        // Apple Pay functionality removed
        setD(false);
        return;
      default:
        setD(false);
        return;
    }
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const isActive = async () => {
    setStateTxt('');

    // Use StoreData directly if available
    if (StoreData && StoreData.timing) {
      const availableTimes = calculateAvailableTimesFromStoreData(StoreData);

      if (!availableTimes.asap) {
        const timeText =
          orderType === 'delivery' || orderType === 'noDriverDelivery'
            ? 'Only available during business hours'
            : 'Only available during business hours';
        setStateTxt(timeText);
        setIsBusy(true);
      } else {
        setStateTxt(t('confirmPage.CurrentlyClosed'));
      }

      setSlots(availableTimes);

      return;
    }

    let restId;
    if (
      environment.restaurantId === 'ttJordan' ||
      environment.restaurantId === 'ttJordanDev' ||
      environment.restaurantId === 'fattyPattyDev' ||
      environment.restaurantId === 'fattyPatty'
    ) {
      restId = storeIdD;
    } else {
      restId =
        orderType === 'delivery' || orderType === 'noDriverDelivery'
          ? deliveryStore
          : storeIdD;
    }

    // Add validation to prevent Firebase error
    if (!restId || restId.trim() === '') {
      setStateTxt('Store information not available');
      return;
    }

    const res = await getTimeZones(restId, setErr);

    if (res === false) {
      setStateTxt('Only available during business hours');
      return setIsBusy(true);
    } else if (res && res?.asap == false) {
      setStateTxt(t('confirmPage.CurrentlyClosed'));
    } else {
      setStateTxt('');
    }

    let dataofRespond = convertTimeSlots(res);

    setSlots(dataofRespond);
  };

  function convertTimeSlots(data) {
    const convertedData = {};
    for (const key in data) {
      if (key === 'asap') {
        convertedData.asap = data.asap;
      } else {
        const dayName =
          key === 'today'
            ? 'today'
            : key === 'tomorrow'
            ? 'tomorrow'
            : 'afterTomorrow';
        const daySlots = data[key].map((slot, index) => {
          const timeRange = slot.time.split(' - ');
          return `${timeRange[0]} - ${timeRange[1]}`;
        });
        convertedData[dayName] = daySlots;
      }
    }
    return convertedData;
  }

  // =========================================

  const handleChange = (event) => {
    if (unavailableNow) {
      setSelectedValue(false);
    } else {
      setSelectedValue(event.target.value);
    }
  };

  // Always display time in 12-hour AM/PM format (ignores locale/device)
  const formatTimeTo12Hour = (timeStr) => {
    if (!timeStr || typeof timeStr !== 'string') return timeStr || '';
    const formatOne = (s) => {
      const t = String(s).trim();
      if (/AM|PM/i.test(t)) {
        const m = t.match(/^(\d{1,2}):(\d{1,2})(?::\d{1,2})?\s*(AM|PM)$/i);
        if (m)
          return `${parseInt(m[1], 10)}:${String(
            parseInt(m[2], 10) || 0
          ).padStart(2, '0')} ${m[3].toUpperCase()}`;
      }
      const match = t.match(/(\d{1,2}):(\d{1,2})/);
      if (match) {
        let hour = parseInt(match[1], 10);
        const minute = String(parseInt(match[2], 10) || 0).padStart(2, '0');
        const period = hour >= 12 ? 'PM' : 'AM';
        hour = hour % 12 || 12;
        return `${hour}:${minute} ${period}`;
      }
      return t;
    };
    if (timeStr.includes(' - ')) {
      const [a, b] = timeStr.split(' - ');
      return `${formatOne(a)} - ${formatOne(b)}`;
    }
    return formatOne(timeStr);
  };

  const onTimeSelected = (data, index) => {
    setRealTime(sendTime);
    handleClose();

    // Parse the user-selected time (e.g., "5:00 PM - 6:00 PM")
    const startTimeStr = data.split(' - ')[0].trim();

    // Parse hour and AM/PM
    const [timeHourMin, period] =
      startTimeStr.includes('AM') || startTimeStr.includes('PM')
        ? startTimeStr.split(/\s+/)
        : [startTimeStr, null];

    const [hourStr, minuteStr] = timeHourMin.split(':');
    let hour = parseInt(hourStr);
    const minute = parseInt(minuteStr) || 0;

    // Convert to 24-hour format
    if (period) {
      if (period.toUpperCase() === 'PM' && hour !== 12) {
        hour = hour + 12;
      } else if (period.toUpperCase() === 'AM' && hour === 12) {
        hour = 0;
      }
    }

    // Create the target date
    const targetDate = new Date();

    if (sendTime === tomorrow) {
      targetDate.setDate(targetDate.getDate() + 1);
    } else if (sendTime === afterTomorrow) {
      targetDate.setDate(targetDate.getDate() + 2);
    }

    // Set the user's local time
    targetDate.setHours(hour, minute, 0, 0);

    // Convert to UTC for backend submission
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const utcDate = convertUserTimeToUTC(
      startTimeStr,
      userTimezone,
      targetDate
    );

    // Store the UTC date for backend submission
    setDateOfOrder(utcDate);
    setSelectedTime({ index, data, sendTime });
    setPrev(sendTime);
    setRange(index);

    // Sync to redux so isScheduleExpired stays accurate when the user picks
    // a time from the inline picker (not the reschedule dialog)
    const displayTime = data?.includes(' - ') ? data.split(' - ')[0].trim() : data;
    const payload = {
      isAsap: false,
      dateOfOrder: utcDate,
      sendTime,
      displayTime,
      selectedTime: { index, data, sendTime },
      storeId: StoreData?.id || storeId,
    };
    dispatch(UpdateScheduledTime(payload));
    dispatch(UpdateCartData({ ...cartDataRef.current, scheduledTime: payload }));
  };

  // Handler for Google Pay button click - auto-submit order after tokenization
  const handleGooglePaySuccess = (token) => {
    setSourceId(token);
    // Trigger onConfirm immediately with the token to avoid state timing issues
    // onConfirm(token);
  };

  const closeConfirmDialog = () => {
    setConfirmDialog(false);
  };

  // Called when user picks a new time slot in the reschedule dialog
  const handleRescheduleConfirm = useCallback(
    (schedulingData) => {
      const payload = { ...schedulingData, storeId: StoreData?.id || storeId };
      dispatch(UpdateScheduledTime(payload));
      dispatch(UpdateCartData({ ...cartDataRef.current, scheduledTime: payload }));

      if (schedulingData.isAsap) {
        setSelectedValue('a');
        setDateOfOrder(null);
      } else {
        setSelectedValue('b');
        setDateOfOrder(schedulingData.dateOfOrder);
        setRealTime(schedulingData.sendTime);
        setSendTime(schedulingData.sendTime);
      }

      setRescheduleDialogOpen(false);
      // Proceed straight to the confirm dialog
      setConfirmDialog(true);
    },
    [dispatch, StoreData?.id, storeId, cartDataRef]
  );

  const handlePaymentMethodConfirm = async (
    selectedMethod,
    selectedSourceId,
    billingData
  ) => {
    // Payment method and sourceId are already set by the dialog
    // Update refs immediately (synchronous) so they're available right away
    paymentMethodRef.current = selectedMethod;
    sourceIdRef.current = selectedSourceId;

    // Also update state (asynchronous, but refs are already set)
    setPaymentMethod(selectedMethod);
    setSourceId(selectedSourceId);

    // Close the payment method dialog
    setPaymentMethodDialog(false);

    // Payment is already tokenized, now automatically fire the checkout function
    // Use a small delay to ensure dialog closes, then call checkout
    setTimeout(async () => {
      await onConfirm(selectedSourceId, billingData);
    }, 100);
  };

  // Helper function to transform customization format
  const transformCustomization = (customization) => {
    const transformed = {};

    if (customization && typeof customization === 'object') {
      Object.keys(customization).forEach((modifierGroupId) => {
        const options = customization[modifierGroupId];
        if (Array.isArray(options)) {
          transformed[modifierGroupId] = options.map((option) => ({
            id: option.id,
            price: option.price || 0,
            quantity: option.quantity || 1,
            name: option.modifierTitle || option.title || '',
            ...(option.text && { text: option.text }), // Include text field for text modifiers
          }));
        }
      });
    }

    return transformed;
  };

  // Helper function to calculate total amount
  const calculateTotalAmount = (cartItems, tipAmount, deliveryId) => {
    const subtotal = cartItems.reduce(
      (sum, item) => sum + (item.calculatedPrice || 0),
      0
    );
    const tips = tipAmount || 0;

    // Add delivery fees, taxes, and service fees based on order type
    let fees = 0;
    let taxes = 0;

    if (orderType === 'delivery' && deliveryId) {
      fees += defaultStorefee?.delivery_fee || 0;
    }

    if (defaultStorefee?.tax?.type === 'amount') {
      taxes = defaultStorefee?.tax?.tax || 0;
    } else {
      taxes = subtotal * (defaultStorefee?.tax?.tax || 0);
    }

    const serviceFee =
      orderType === 'delivery'
        ? defaultStorefee?.service_fee?.delivery || 0
        : orderType === 'pickup'
        ? defaultStorefee?.service_fee?.pickUp || 0
        : defaultStorefee?.service_fee?.dineIn || 0;

    return parseFloat((subtotal + tips + fees + taxes + serviceFee).toFixed(2));
  };

  function getAvailableTimeSlots(endTime) {
    const currentTime = new Date();
    const currentTimestamp = currentTime?.getTime();
    // Constructing a JavaScript Date object from Firestore-like object
    const dateObject = endTime
      ? new Date(endTime.seconds * 1000 + endTime.nanoseconds / 1000000)
      : null;
    if (dateObject instanceof Date) {
      const endTimestamp = dateObject?.getTime();
      if (!isNaN(endTimestamp)) {
        if (endTimestamp < currentTimestamp) {
          return false; // If endTime is in the past (unavailable)
        } else {
          return true; // If endTime is in the future (available)
        }
      } else {
        return false; // Invalid endTime
      }
    } else {
      return false; // Treat as available if endTime is undefined or not a Date object
    }
  }

  const onConfirmClover = async (c) => {
    // Prevent duplicate checkout requests
    if (isCheckoutProcessingRef.current) {
      return;
    }

    isCheckoutProcessingRef.current = true;
    setLoading(true);
    setErr('');
    try {
      const types = { googlePay: 'google_pay', applePay: 'apple_pay' };
      const type = 'clover';
      const deliveryOrPickup = orderType;
      const storeId = storeIdD || user?.defaultStore;
      const billingZipcode = userCard?.address_zip ? userCard?.address_zip : '';
      const paymentData = c;
      const cartItems = user?.bagItems;
      const phoneNumber = user?.phoneNumber;
      //note
      const deliveryIdForClover = effectiveDeliveryId;

      let dateOrderScheduling;
      let isScheduling;
      if (orderType === 'dinein') {
        dateOrderScheduling = null;
        isScheduling = false;
      }

      if (orderType !== 'dinein') {
        isScheduling = selectedValue !== 'a';
        dateOrderScheduling = dateOfOrder;

        if (!dateOrderScheduling && isScheduling) {
          setErr(t('confirmPage.pleaseChooseDate'));
          isCheckoutProcessingRef.current = false;
          setLoading(false);
          return;
        }
      }

      const uid = auth?.currentUser.getIdToken().then(async (token) => {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: token,
        };

        const transformedCartItems = cartItems.map((item) => ({
          itemId: item.itemId,
          variationId: item.variationId || item.itemId,
          variationName: item.variationName || '',
          customization: transformCustomization(item.customization),
          quantity: item.quantity,
          calculatedPrice: item.calculatedPrice,
        }));

        // Calculate total amount (subtotal + taxes + fees + tips)
        const totalAmount = calculateTotalAmount(
          cartItems,
          tipAmount,
          deliveryIdForClover
        );

        const transformedPayload = {
          uid: auth?.currentUser?.uid,
          cartItems: transformedCartItems,
          deliveryOrPickup: deliveryOrPickup || 'pickup',
          deliveryId: deliveryIdForClover,
          isScheduling: isScheduling,
          dateOrderScheduling: dateOrderScheduling,
          storeId: storeId,
          totalAmount: totalAmount,
          type: type,
          tipAmount: tipAmount,
          note: note,
          paymentData: paymentData,
          ...(selectedOffer
            ? {
                useLoyalty: true,
                programId:
                  environment.restaurantId === 'fattyPattyDev'
                    ? '832fe29b-3700-4977-ad33-be88f6aa9a54'
                    : 'a66ddd7b-362d-4fea-ab5b-dd06974aaf21',
                rewardTierId: selectedOffer,
              }
            : {}),
        };

        const { data } = await axios.post(
          `${environment?.apiUrl}/checkoutV3?restaurantId=${environment.restaurantId}`,
          transformedPayload,
          { headers }
        );
        await firestore.collection('users').doc(auth?.currentUser?.uid).set(
          {
            bagItems: [],
          },
          { merge: true }
        );
        dispatch(setCart([]));
        const updatedUser = { ...user, bagItems: [] };
        dispatch(setUser({ userData: updatedUser }));
        dispatch(UdpateNote(''));
        isCheckoutProcessingRef.current = false;
        setLoading(false);
        setOpenSuccess(true);
      });
    } catch (e) {
      isCheckoutProcessingRef.current = false;
      setLoading(false);
      setErr(
        e.response?.data?.message ||
          t('confirmPage.somethingWrongTryAgainLater')
      );
    }
  };

  // OTP verification functions
  const generateRecaptcha = () => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new recaptchaVerifier(
        'recaptcha-container-checkout',
        {
          size: 'invisible',
        },
        _customApp
      );
    }
  };

  const requestOTP = async () => {
    setOtpError('');
    if (!personalPhone || !isValidPhoneNumber(personalPhone)) {
      setOtpError('Please enter a valid phone number');
      return;
    }

    // Capture the current anonymous UID BEFORE phone verification
    if (isAnonymous && auth?.currentUser?.uid) {
      const currentAnonymousUid = auth.currentUser.uid;
      setCapturedAnonymousUid(currentAnonymousUid);
    }

    setIsSendingOTP(true);
    generateRecaptcha();
    let appvarifier = window.recaptchaVerifier;

    try {
      const confirmationResult = await auth.signInWithPhoneNumber(
        personalPhone,
        appvarifier
      );
      setIsSendingOTP(false);
      setIsPhoneVerification(true);
      window.confirmationResult = confirmationResult;
      window.recaptchaVerifier = null;
      setOtpError('');
    } catch (error) {
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.reset();
      }
      setIsSendingOTP(false);
      setIsPhoneVerification(false);
      setOtpError('Failed to send OTP. Please try again.');
    }
  };

  // When OTP section becomes visible, scroll it into view (especially for small screens)
  useEffect(() => {
    if (isPhoneVerification && otpSectionRef?.current) {
      try {
        otpSectionRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      } catch (e) {
        // ignore
      }
    }
  }, [isPhoneVerification]);

  // Cleanup: clear email validation timeout on unmount
  useEffect(() => {
    return () => {
      if (emailCheckTimeoutRef.current) {
        clearTimeout(emailCheckTimeoutRef.current);
      }
    };
  }, []);

  // ⚠️ CRITICAL: Email existence check using FIREBASE AUTH ONLY (NOT Firestore)
  // This function checks if an email exists in Firebase Authentication system
  // It NEVER queries Firestore database - uses fetchSignInMethodsForEmail API
  // Features: caching with TTL, timeout protection, secure fail-closed behavior
  const checkEmailExists = async (email, currentUserId = null) => {
    if (!email || email.trim() === '') return false;

    const normalizedEmail = email.toLowerCase().trim();
    const currentUser = auth.currentUser;

    console.log(
      '🔍 [Email Check] Checking email existence via Firebase Auth API (NOT Firestore):',
      normalizedEmail
    );

    // Check cache first (5-minute TTL)
    const cached = emailCheckCacheRef.current.get(normalizedEmail);
    if (cached && Date.now() - cached.timestamp < EMAIL_CACHE_TTL) {
      console.log('📦 [Email Check] Using cached result:', cached.exists);
      return cached.exists;
    }

    try {
      // Create timeout promise (3 seconds)
      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Email check timeout')), 3000)
      );

      // ✅ FIREBASE AUTH API CHECK (NOT Firestore)
      // Uses auth.fetchSignInMethodsForEmail - checks Authentication system only
      const authCheckPromise = (async () => {
        try {
          const signInMethods = await auth.fetchSignInMethodsForEmail(
            normalizedEmail
          );

          // Email exists in Firebase Auth
          if (signInMethods && signInMethods.length > 0) {
            // Check if it belongs to current user
            if (
              currentUser &&
              currentUser.email &&
              currentUser.email.toLowerCase() === normalizedEmail
            ) {
              return false; // Email belongs to current user
            }
            return true; // Email exists for another user
          }

          // Email doesn't exist in Auth - only check Firestore for legacy accounts
          // This is rare and only for backward compatibility
          const usersRef = firestore.collection('users');
          const querySnapshot = await usersRef
            .where('email', '==', normalizedEmail)
            .limit(1)
            .get();

          return !querySnapshot.empty;
        } catch (authError) {
          // Fallback to Firestore only on Auth API error
          console.warn(
            'Auth check failed, using Firestore fallback:',
            authError.code
          );
          const usersRef = firestore.collection('users');
          const querySnapshot = await usersRef
            .where('email', '==', normalizedEmail)
            .limit(1)
            .get();
          return !querySnapshot.empty;
        }
      })();

      // Race between auth check and timeout
      const exists = await Promise.race([authCheckPromise, timeoutPromise]);

      // Cache the result
      emailCheckCacheRef.current.set(normalizedEmail, {
        exists,
        timestamp: Date.now(),
      });

      // Limit cache size to prevent memory issues (keep last 100 entries)
      if (emailCheckCacheRef.current.size > 100) {
        const firstKey = emailCheckCacheRef.current.keys().next().value;
        emailCheckCacheRef.current.delete(firstKey);
      }

      return exists;
    } catch (error) {
      // On timeout or error, be safe and assume email might exist
      // Better to show a false warning than allow duplicate emails
      console.error(
        '❌ [Email Check] Error checking email, assuming it exists for safety:',
        error.message
      );
      return true; // Block on error (fail closed for security)
    }
  };

  // Debounced email validation with loading state
  const validateEmailWithDebounce = async (email) => {
    // Clear existing timeout
    if (emailCheckTimeoutRef.current) {
      clearTimeout(emailCheckTimeoutRef.current);
    }

    // Basic validation first
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setPersonalErrors((p) => ({
        ...p,
        email: 'Please enter a valid email',
      }));
      setIsCheckingEmail(false);
      return;
    }

    // Set loading state
    setIsCheckingEmail(true);
    setPersonalErrors((p) => ({ ...p, email: '' }));

    // Debounce: wait 500ms before checking
    emailCheckTimeoutRef.current = setTimeout(async () => {
      try {
        const emailExists = await checkEmailExists(email);

        if (emailExists) {
          setPersonalErrors((p) => ({
            ...p,
            email:
              'This email is already registered. Please login or use a different email.',
          }));
        } else {
          setPersonalErrors((p) => ({ ...p, email: '' }));
        }
      } catch (error) {
        // Silent fail - don't block user on validation errors
        console.error('Email validation error:', error);
      } finally {
        setIsCheckingEmail(false);
      }
    }, 500); // 500ms debounce
  };

  // Helper function to check if phone number exists and get the registered email and names
  const checkPhoneNumberExists = async (phoneNumber) => {
    if (!phoneNumber || !isValidPhoneNumber(phoneNumber)) return null;

    try {
      const usersRef = firestore.collection('users');
      const querySnapshot = await usersRef
        .where('phoneNumber', '==', phoneNumber)
        .limit(1)
        .get();

      if (!querySnapshot.empty) {
        const userData = querySnapshot.docs[0].data();
        return {
          exists: true,
          email: userData.email ? userData.email.toLowerCase().trim() : null,
          firstName: userData.firstName || '',
          lastName: userData.lastName || '',
        };
      }
      return { exists: false, email: null, firstName: '', lastName: '' };
    } catch (error) {
      return null; // Allow to proceed if check fails
    }
  };

  const handlePinChange = (pinCode) => {
    setOTP(pinCode);
    setOtpError('');

    if (pinCode.length === 6) {
      let confirmationResult = window.confirmationResult;

      confirmationResult
        .confirm(pinCode)
        .then(async (userCredential) => {
          setVerifiedNum(true);
          setIsPhoneVerification(false);
          setOtpError('');

          try {
            const uid = userCredential?.user?.uid;
            const authUser = userCredential?.user;
            const anonymousUid = capturedAnonymousUid || user?.uid;

            if (uid) {
              // Check if user already exists in Firestore
              const userDocRef = firestore.collection('users').doc(uid);
              const snapshot = await userDocRef.get();
              const isNewUser = !snapshot.exists;

              setIsExistingUser(!isNewUser);

              // Get email from Firebase Auth (if exists)
              let emailFromAuth = authUser?.email || '';
              let existingFirstName = '';
              let existingLastName = '';
              let existingUserData = {};

              // Fetch user data from Firestore
              if (!isNewUser) {
                existingUserData = snapshot.data();
                const emailFromFirestore = existingUserData?.email || '';
                // Prefer Firestore email if both exist
                emailFromAuth = emailFromFirestore || emailFromAuth;

                // Get existing firstName and lastName
                existingFirstName = existingUserData?.firstName || '';
                existingLastName = existingUserData?.lastName || '';

                // Pre-populate personal data for existing users
                if (existingUserData?.firstName) {
                  setPersonalFirstName(existingUserData.firstName);
                }
                if (existingUserData?.lastName) {
                  setPersonalLastName(existingUserData.lastName);
                }
              }

              // CRITICAL: Create basic user document for new users immediately
              if (isNewUser) {
                await userDocRef.set({
                  uid,
                  phoneNumber: personalPhone,
                  firstName: '',
                  lastName: '',
                  fullName: '',
                  email: '',
                  emailVerified: false,
                  defaultLanguage: 'en',
                  bagItems: [],
                  defaultPaymentAddress: '',
                  defaultDeliveryAddress: '',
                  defaultStore: '',
                  pickupOrDelivery: orderType || 'pickup',
                  createdAt: new Date(),
                });
              }

              // Build basic user data for immediate login
              const basicUserData = {
                ...existingUserData,
                uid,
                phoneNumber: personalPhone,
                firstName: existingFirstName,
                lastName: existingLastName,
                fullName: existingUserData?.fullName || '',
                email: emailFromAuth,
                bagItems: existingUserData?.bagItems || [],
                pickupOrDelivery:
                  existingUserData?.pickupOrDelivery || orderType || 'pickup',
                defaultDeliveryAddress:
                  existingUserData?.defaultDeliveryAddress || '',
              };

              // CRITICAL: Log user in immediately by updating Redux and localStorage
              window.localStorage.setItem('docid', uid);
              window.localStorage.setItem(
                'skipCartSync',
                Date.now().toString()
              );

              dispatch(setUser({ userData: basicUserData }));
              dispatch(
                loggedInSuccess({
                  token: uid,
                  isAnonymous: false,
                })
              );
              dispatch(setAnonymousStatus(false));

              // Store auth user data for dialog (if needed)
              setAuthUserData({
                uid,
                authUser,
                anonymousUid,
                isNewUser,
              });

              // Set email and names for the dialog
              setTempEmail(emailFromAuth);
              setPersonalEmail(emailFromAuth);
              setTempFirstName(existingFirstName);
              setTempLastName(existingLastName);
              setPersonalFirstName(existingFirstName);
              setPersonalLastName(existingLastName);

              // ALWAYS perform migration and cart setup immediately after OTP (regardless of profile completeness)
              // Migrate anonymous user data if needed
              let firstMigratedAddressId = null;
              let migratedBagItems = [];

              if (isAnonymous && anonymousUid && anonymousUid !== uid) {
                try {
                  const anonymousUserDocRef = firestore
                    .collection('users')
                    .doc(anonymousUid);
                  const anonymousUserDoc = await anonymousUserDocRef.get();

                  if (anonymousUserDoc.exists) {
                    // Migrate addresses
                    const anonymousAddressesRef = firestore
                      .collection('users')
                      .doc(anonymousUid)
                      .collection('addresses');
                    const anonymousAddressesSnapshot =
                      await anonymousAddressesRef.get();
                    const anonymousAddresses = [];

                    anonymousAddressesSnapshot.forEach((doc) => {
                      anonymousAddresses.push({ id: doc.id, ...doc.data() });
                    });

                    if (anonymousAddresses.length > 0) {
                      const authenticatedAddressesRef = firestore
                        .collection('users')
                        .doc(uid)
                        .collection('addresses');

                      const authenticatedAddressesSnapshot =
                        await authenticatedAddressesRef.get();
                      const hasExistingAddresses =
                        !authenticatedAddressesSnapshot.empty;

                      for (const address of anonymousAddresses) {
                        const addressData = {
                          ...address,
                          isAnonymousAddress: false,
                          migratedAt: new Date(),
                          migratedFrom: anonymousUid,
                        };
                        delete addressData.id;

                        const newAddressRef =
                          await authenticatedAddressesRef.add(addressData);

                        if (!firstMigratedAddressId) {
                          firstMigratedAddressId = newAddressRef.id;
                        }
                      }

                      if (!hasExistingAddresses && firstMigratedAddressId) {
                        await userDocRef.update({
                          defaultDeliveryAddress: firstMigratedAddressId,
                        });
                      }

                      for (const address of anonymousAddresses) {
                        await anonymousAddressesRef.doc(address.id).delete();
                      }
                    }

                    // Migrate cart items from Firestore
                    const anonymousData = anonymousUserDoc.data();
                    if (anonymousData.bagItems?.length > 0) {
                      migratedBagItems = anonymousData.bagItems;
                    }

                    await anonymousUserDocRef.delete();
                  }
                } catch (migrationError) {
                  console.error('Migration error:', migrationError);
                }
              }

              // CRITICAL: Ensure current delivery address is saved to Firestore if user is ordering delivery
              if (
                orderType === 'delivery' &&
                currentDeliveryAddressId &&
                currentDeliveryAddressData
              ) {
                try {
                  // Check if address exists in user's Firestore collection
                  const addressDocRef = userDocRef
                    .collection('addresses')
                    .doc(currentDeliveryAddressId);
                  const addressDoc = await addressDocRef.get();

                  if (!addressDoc.exists) {
                    // Save the address to Firestore
                    await addressDocRef.set({
                      ...currentDeliveryAddressData,
                      createdAt:
                        currentDeliveryAddressData.createdAt || new Date(),
                      validated_on:
                        currentDeliveryAddressData.validated_on || new Date(),
                    });

                    // Set as first migrated address if we don't have one yet
                    if (!firstMigratedAddressId) {
                      firstMigratedAddressId = currentDeliveryAddressId;
                    }
                  }
                } catch (addressSaveError) {
                  console.error(
                    '🏠 [Address] ❌ Error saving address:',
                    addressSaveError
                  );
                }
              }

              // Get the CURRENT cart from Redux cart state
              const anonymousBagItems = reduxCart || user?.bagItems || [];

              // Use migrated items if available, otherwise use current Redux cart items
              const finalBagItems =
                migratedBagItems.length > 0
                  ? migratedBagItems
                  : anonymousBagItems;

              // Fetch user data BEFORE updating cart to preserve other user fields
              const existingUserDoc = await userDocRef.get();
              const currentUserData = existingUserDoc.data() || {};

              // Save cart and order preferences to Firestore
              const anonymousOrderType =
                orderType || user?.pickupOrDelivery || 'pickup';
              const anonymousDeliveryAddressId =
                deliveryStore?.address ||
                firstMigratedAddressId ||
                currentDeliveryAddressId ||
                user?.defaultDeliveryAddress ||
                '';

              await userDocRef.set(
                {
                  bagItems: finalBagItems,
                  lastCartUpdate: new Date(),
                  pickupOrDelivery: anonymousOrderType,
                  ...(anonymousDeliveryAddressId && {
                    defaultDeliveryAddress: anonymousDeliveryAddressId,
                  }),
                },
                { merge: true }
              );

              // Update Redux with complete cart data
              const anonymousScheduledTime = scheduledTime || null;

              dispatch(
                UpdateCartData({
                  orderType: anonymousOrderType,
                  scheduledTime: anonymousScheduledTime,
                  storeId: cartStoreId || '',
                  apiPricingData: apiPricingData,
                })
              );

              // Update deliveryAddress in Redux if we have one
              if (anonymousDeliveryAddressId) {
                migratedAddressIdRef.current = anonymousDeliveryAddressId;

                const addressDocToUse = await userDocRef
                  .collection('addresses')
                  .doc(anonymousDeliveryAddressId)
                  .get();

                if (addressDocToUse.exists) {
                  const addressData = addressDocToUse.data();

                  dispatch(
                    setDeliveryStore({
                      address: anonymousDeliveryAddressId,
                      store: addressData?.storeId || cartStoreId || '',
                      source: 'authentication',
                    })
                  );
                }
              }

              // Update Redux user data with migrated data
              const finalUserData = {
                ...currentUserData,
                uid,
                phoneNumber: personalPhone,
                firstName: currentUserData.firstName || existingFirstName,
                lastName: currentUserData.lastName || existingLastName,
                fullName: currentUserData.fullName || '',
                email: currentUserData.email || emailFromAuth,
                bagItems: finalBagItems,
                pickupOrDelivery: anonymousOrderType,
                ...(anonymousDeliveryAddressId && {
                  defaultDeliveryAddress: anonymousDeliveryAddressId,
                }),
              };

              dispatch(setUser({ userData: finalUserData }));

              // Check if we need to collect missing information
              const needsEmail =
                !finalUserData.email || finalUserData.email.trim() === '';
              const needsFirstName =
                !finalUserData.firstName ||
                finalUserData.firstName.trim() === '';
              const needsLastName =
                !finalUserData.lastName || finalUserData.lastName.trim() === '';

              if (needsEmail || needsFirstName || needsLastName) {
                // Reset email change state when dialog opens
                setHasEmailChanged(false);
                // Show dialog to collect missing personal information
                setShowEmailDialog(true);
              } else {
                // User has complete profile
                setEmailConfirmed(true);
              }
            }
          } catch (e) {
            setOtpError(
              'An error occurred during verification. Please try again.'
            );
            console.error('Error in handlePinChange:', e);
          }
        })
        .catch((e) => {
          const notCorrect =
            'The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.';
          setOtpError(
            e.message === notCorrect
              ? 'Incorrect code. Please resend and try again.'
              : e.message
          );
        });
    }
  };

  // Handler to submit email from email dialog - ONLY updates personal info (email, firstName, lastName)
  const handleEmailSubmit = async () => {
    setEmailDialogError('');

    const normalizedEmail = tempEmail.toLowerCase().trim();
    const normalizedFirstName = tempFirstName.trim();
    const normalizedLastName = tempLastName.trim();
    const originalEmail = (personalEmail || authUserData?.email || '')
      .trim()
      .toLowerCase();
    const emailChanged = normalizedEmail !== originalEmail;
    const currentAuthUser = auth?.currentUser || null;
    const authHasEmail = !!(currentAuthUser && currentAuthUser.email);

    // Validate all required fields
    if (
      !normalizedEmail ||
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail)
    ) {
      setEmailDialogError('Please enter a valid email address');
      return;
    }

    if (!normalizedFirstName) {
      setEmailDialogError('Please enter your first name');
      return;
    }

    if (normalizedFirstName.length < 2 || normalizedFirstName.length > 20) {
      setEmailDialogError('First name must be between 2 and 20 characters');
      return;
    }

    if (!/^[a-zA-Z\s]+$/.test(normalizedFirstName)) {
      setEmailDialogError('First name can only contain letters');
      return;
    }

    if (!normalizedLastName) {
      setEmailDialogError('Please enter your last name');
      return;
    }

    if (normalizedLastName.length < 2 || normalizedLastName.length > 20) {
      setEmailDialogError('Last name must be between 2 and 20 characters');
      return;
    }

    if (!/^[a-zA-Z\s]+$/.test(normalizedLastName)) {
      setEmailDialogError('Last name can only contain letters');
      return;
    }

    setIsUpdatingEmail(true);

    try {
      // If authUserData is null (after refresh), recreate it from current auth user
      let userData = authUserData;
      if (!userData && auth?.currentUser) {
        console.log(
          '🔄 [handleEmailSubmit] Recreating authUserData from current Firebase Auth user'
        );
        userData = {
          uid: auth.currentUser.uid,
          authUser: auth.currentUser,
        };
      }

      if (!userData) {
        console.log(
          '❌ [handleEmailSubmit] No authUserData and no currentUser'
        );
        setEmailDialogError(
          'Authentication error. Please try logging in again.'
        );
        setIsUpdatingEmail(false);
        return;
      }

      const { uid, authUser } = userData;

      // Decide whether we actually need to link an Auth email at all.
      // IMPORTANT for checkout:
      // - If the Firebase Auth user already has an email, we treat this dialog
      //   as "contact info only" and NEVER touch the Auth email from here.
      // - If the Auth user has NO email yet (phone-only account), we link
      //   an email+password credential ONCE using a random password, so Auth
      //   enforces email uniqueness without forcing the user to re-login.
      const shouldLinkAuthEmail =
        !authHasEmail && !!normalizedEmail && (!originalEmail || emailChanged);

      try {
        if (shouldLinkAuthEmail && currentAuthUser) {
          const randomPassword =
            Math.random().toString(36).slice(-10) + Date.now().toString(36);

          const credential = firebase.auth.EmailAuthProvider.credential(
            normalizedEmail,
            randomPassword
          );

          await currentAuthUser.linkWithCredential(credential);
        }

        // API call succeeded - now update Firestore and close dialog
        // Update personal info states
        setPersonalEmail(normalizedEmail);
        setPersonalFirstName(normalizedFirstName);
        setPersonalLastName(normalizedLastName);

        // Update user document with personal info ONLY
        const userDocRef = firestore.collection('users').doc(uid);

        const firstName = normalizedFirstName;
        const lastName = normalizedLastName;
        const formattedFirstName = firstName
          ? firstName.charAt(0).toUpperCase() + firstName.slice(1)
          : '';
        const formattedLastName = lastName
          ? lastName.charAt(0).toUpperCase() + lastName.slice(1)
          : '';
        const fullName = `${formattedFirstName} ${formattedLastName}`.trim();

        // ONLY update personal information - cart and addresses already migrated in OTP handler
        await userDocRef.set(
          {
            firstName: formattedFirstName,
            lastName: formattedLastName,
            fullName: fullName,
            email: normalizedEmail,
            emailVerified: true,
            emailVerificationSentAt: null,
          },
          { merge: true }
        );

        // Fetch updated user data and update Redux
        const updatedUserDoc = await userDocRef.get();
        const updatedUserData = updatedUserDoc.data() || {};

        const finalUserData = {
          ...updatedUserData,
          uid,
        };

        // Update Redux with new personal info
        dispatch(setUser({ userData: finalUserData }));

        // Clear dialog error (if any) and close email dialog
        setEmailDialogError('');
        setShowEmailDialog(false);
        setIsUpdatingEmail(false);
        setEmailConfirmed(true); // Mark personal info/email as confirmed
      } catch (error) {
        console.error('❌ [Auth/API] Failed to update email:', error);
        console.error('❌ [Auth/API] Error message:', error?.message);

        // Block the flow - show error message from API and keep dialog open
        const errorMessage =
          error?.message || 'Failed to update email. Please try again.';
        setEmailDialogError(errorMessage);
        setIsUpdatingEmail(false);
        // Dialog stays open, no Firestore update, no Redux update
        return;
      }
    } catch (error) {
      console.error('Error in handleEmailSubmit:', error);
      setEmailDialogError('An error occurred. Please try again.');
      setIsUpdatingEmail(false);
    }
  };

  // Handler to navigate back to menu while preserving state (store, order type, scheduled time)
  const handleBackToMenu = useCallback(() => {
    // Reset payment token when going back to menu
    // setSourceId(null);
    // Get current store data from stores array
    const currentStore = stores?.find((s) => s.id === cartStoreId);

    console.log('\n🔙🔙🔙 [ConfirmOrderPage] === NAVIGATING BACK TO MENU ===');
    console.log('🔙 [ConfirmOrderPage] Cart Items:', user?.bagItems);
    console.log(
      '🔙 [ConfirmOrderPage] Cart Items Count:',
      user?.bagItems?.length || 0
    );
    console.log('🔙 [ConfirmOrderPage] Order Type:', orderType);
    console.log('🔙 [ConfirmOrderPage] Cart Store ID:', cartStoreId);
    console.log('🔙 [ConfirmOrderPage] Current Store:', currentStore);
    console.log(
      "🔙 [ConfirmOrderPage] Cart's Original Scheduled Time (from cartData):",
      scheduledTime
    );
    console.log(
      '🔙 [ConfirmOrderPage] Scheduled Time Store ID:',
      scheduledTime?.storeId
    );
    console.log('🔙 [ConfirmOrderPage] Navigation State:', {
      store: currentStore || null,
      preserveOrderType: orderType,
      preserveScheduledTime: scheduledTime || null,
      fromCart: true,
      storeId: cartStoreId,
    });
    console.log('🔙🔙🔙 [ConfirmOrderPage] === END NAVIGATION DATA ===\n');

    // Navigate to menu with state to preserve context
    navigate('/menu', {
      state: {
        store: currentStore || null,
        preserveOrderType: orderType,
        preserveScheduledTime: scheduledTime || null,
        fromCart: true,
        storeId: cartStoreId,
      },
    });
  }, [cartStoreId, stores, orderType, scheduledTime, navigate, user?.bagItems]);

  // Validate personal info (used before opening confirm dialog)
  const validatePersonalInfo = async () => {
    if (!isAnonymous) return true;

    // Only check phone number since email and names are now handled via dialogs after OTP
    const phoneVal = personalPhone;

    const nextErrors = {
      firstName: '',
      lastName: '',
      email: '',
      phone:
        !phoneVal || !isValidPhoneNumber(phoneVal)
          ? 'Please enter a valid phone number'
          : '',
    };

    setPersonalErrors(nextErrors);

    // If phone is invalid, return false
    if (nextErrors.phone) {
      return false;
    }

    // If phone is valid but user hasn't verified yet, they need to complete OTP flow
    if (!verifiedNum) {
      return false;
    }

    return true;
  };

  useEffect(() => {
    // Scroll to top when page loads (important for mobile)
    window.scrollTo(0, 0);

    setDefaultStoreAdress(
      filteredStore?.address?.displayName ||
        filteredStore?.address?.addressLine1
    );
    getENV();
    getUser();
    getOrders();
    fetchSavedCards();
  }, []);

  useEffect(() => {
    const isAvailable = getAvailableTimeSlots(StoreData?.endTime);

    setUnAvailableNow(isAvailable);
  }, [StoreData?.endTime, StoreData]);

  // Reset sourceId when payment method changes to ensure fresh tokenization
  // useEffect(() => {
  //   console.log('💳 [useEffect] Payment method changed to:', paymentMethod);
  //   setSourceId(null);
  // }, [paymentMethod]);

  useEffect(() => {
    isActive();
    getStoreData();
  }, [storeId, deliveryStore, storeIdD, orderType]);

  // Reset selected time when order type changes (pickup vs delivery have different time intervals)
  // But preserve scheduled time from Redux if it exists
  useEffect(() => {
    // Only clear if there's no scheduled time saved in Redux
    if (!scheduledTime) {
      setSelectedTime({});
      setRange('');
      setPrev('');
    }
  }, [orderType, scheduledTime]);

  useEffect(() => {
    if (storeIdFromState) {
      setStoreId(storeIdFromState);
    }
  }, [storeIdFromState]);

  // Pre-populate scheduled time if it exists
  // Match slot by time string (not index) since SchedulingDialog and ConfirmOrderPage
  // may generate different slot arrays (different prep times, current-time cutoff)
  useEffect(() => {
    if (!scheduledTime) return;

    if (scheduledTime.isAsap) {
      setSelectedValue('a');
      return;
    }

    if (!scheduledTime.dateOfOrder) return;

    setSelectedValue('b');
    setDateOfOrder(scheduledTime.dateOfOrder);
    setRealTime(scheduledTime.sendTime);
    setSendTime(scheduledTime.sendTime);
    setPrev(scheduledTime.selectedTime?.sendTime || scheduledTime.sendTime);

    const timeKey = scheduledTime.sendTime || 'today';
    const daySlots = slots[timeKey];
    const timeToMatch =
      scheduledTime.selectedTime?.data || scheduledTime.displayTime || '';

    // Find matching slot by time string (handles different slot generation between pages)
    let matchedIndex = scheduledTime.selectedTime?.index;
    let matchFound = false;
    if (daySlots && daySlots.length > 0 && timeToMatch) {
      const normalizedMatch = (str) =>
        (str || '').toString().trim().replace(/\s+/g, ' ').toUpperCase();
      const matchStr = normalizedMatch(timeToMatch);
      const startTimeMatch = timeToMatch.includes(' - ')
        ? normalizedMatch(timeToMatch.split(' - ')[0])
        : matchStr;

      const found = daySlots.findIndex((slot) => {
        const slotNorm = normalizedMatch(slot);
        const slotStart = slot.includes(' - ')
          ? normalizedMatch(slot.split(' - ')[0])
          : slotNorm;
        return slotNorm === matchStr || slotStart === startTimeMatch;
      });

      if (found >= 0) {
        matchedIndex = found;
        matchFound = true;
      }
    }

    // When no slot match, preserve the actual selected time - do NOT use index
    // from a different slot array (SchedulingDialog vs ConfirmOrderPage differ)
    const finalData = matchFound
      ? daySlots?.[matchedIndex] ?? scheduledTime.selectedTime?.data
      : scheduledTime.selectedTime?.data || scheduledTime.displayTime;
    setSelectedTime({
      ...(scheduledTime.selectedTime || {}),
      index: matchedIndex,
      data: finalData,
      sendTime: scheduledTime.sendTime,
    });
    setRange(matchedIndex);
  }, [scheduledTime, slots]);

  // Check for missing personal info on page load/refresh and show dialog if needed
  // ONLY for authenticated users who are missing required information
  useEffect(() => {
    // Skip entirely if user is anonymous - personal info flow handled during OTP
    if (isAnonymous) {
      return;
    }

    // Skip if no authenticated user
    if (!user?.uid) {
      return;
    }

    // Check if user already has complete information
    const email = user?.email || '';
    const firstName = user?.firstName || '';
    const lastName = user?.lastName || '';

    const hasCompleteInfo =
      email.trim() !== '' && firstName.trim() !== '' && lastName.trim() !== '';

    // If user already has complete info, skip all checks and mark as confirmed
    if (hasCompleteInfo) {
      console.log(
        '✅ [Refresh Check] User already has complete info, skipping personal info flow'
      );

      // Pre-populate fields silently (no dialog needed)
      setPersonalEmail(email);
      setPersonalFirstName(firstName);
      setPersonalLastName(lastName);

      // Mark as confirmed without showing dialog - only if not already confirmed
      setEmailConfirmed(true);

      return; // Exit - no dialog or section needed
    }

    // User is authenticated but missing some required info - show dialog
    console.log(
      '🔍 [Refresh Check] Authenticated user missing personal info, showing dialog'
    );
    console.log('Missing data:', {
      hasEmail: email.trim() !== '',
      hasFirstName: firstName.trim() !== '',
      hasLastName: lastName.trim() !== '',
    });

    // Pre-populate what we have
    if (email) {
      setPersonalEmail(email);
      setTempEmail(email);
    }
    if (firstName) {
      setPersonalFirstName(firstName);
      setTempFirstName(firstName);
    }
    if (lastName) {
      setPersonalLastName(lastName);
      setTempLastName(lastName);
    }

    // Set authUserData if not already set (for dialog submission)
    if (!authUserData && auth?.currentUser) {
      setAuthUserData({
        uid: user.uid,
        authUser: auth.currentUser,
        anonymousUid: null,
        isNewUser: false,
      });
      // Set as existing user since they have an account
      setIsExistingUser(true);
    }

    // Reset email change state when dialog opens
    setHasEmailChanged(false);

    // Show dialog to collect missing info
    setShowEmailDialog(true);
  }, [isAnonymous, user?.uid, user?.email, user?.firstName, user?.lastName]);

  // Localized, timezone-aware labels for Today/Tomorrow used in the inline scheduler
  const _locale = i18n?.language || 'en-US';
  const _timeZone =
    (filteredStore && filteredStore.timezone) ||
    (store && store.timezone) ||
    Intl.DateTimeFormat().resolvedOptions().timeZone;

  const _formatDateLabel = (offset) => {
    const now = new Date();
    const target = new Date(now);
    target.setDate(target.getDate() + offset);
    return new Intl.DateTimeFormat(_locale, {
      timeZone: _timeZone,
      weekday: 'short',
      month: 'short',
      day: 'numeric',
    }).format(target);
  };

  const todayLabelInline = _formatDateLabel(0);
  const tomorrowLabelInline = _formatDateLabel(1);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {(environment?.restaurantId === 'fattyPattyDev' ||
        environment?.restaurantId === 'fattyPatty') && (
        <SectionHeader
          title="checkout"
          breadcrumbs={[
            { label: 'Home', path: '/' },
            { label: 'Checkout', current: true },
          ]}
          fontFamily="Jost"
          showBreadcrumbs={true}
          titleVariant="h2"
          customStyles={{
            title: { fontSize: '40px', fontWeight: '700' },
            container: { minHeight: '250px' },
          }}
        />
      )}

      {environment?.restaurantId !== 'fattyPattyDev' &&
        environment?.restaurantId !== 'fattyPatty' && (
          <Container maxWidth={'xl'}>
            <div
              className={classes.flexJustifyCenter}
              style={{
                marginBottom: '30px',
              }}
            >
              <Typography
                variant="h3"
                style={{
                  fontFamily: 'Caveat',
                  fontWeight: 'bold',
                  fontSize: '50px',
                  color: environment?.mainColor,
                }}
              >
                {t('confirmPage.details')}
              </Typography>
            </div>
            <Divider style={{ marginBottom: '60px' }} />
          </Container>
        )}

      {/* Back Navigation */}
      <Box
        maxWidth={'xl'}
        sx={{
          paddingTop: '30px',
          paddingBottom: '20px',
          paddingX: {
            xs: '10px',
            sm: '20px',

            xl: '50px',
          },
        }}
      >
        <Box
          onClick={() => navigate(-1)}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 16px',
            backgroundColor: '#ffffff',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            boxShadow: '0 1px 4px rgba(0, 0, 0, 0.06)',
            cursor: 'pointer',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            position: 'relative',
            overflow: 'hidden',
            maxWidth: 'fit-content',
            '&:hover': {
              backgroundColor: environment?.mainColor || '#1976d2',
              borderColor: environment?.mainColor || '#1976d2',
              boxShadow: '0 2px 12px rgba(0, 0, 0, 0.12)',
              transform: 'translateY(-1px)',
              '& .back-icon': {
                color: 'white',
                transform: 'translateX(-2px)',
              },
              '& .back-text': {
                color: 'white',
              },
            },
            '&:active': {
              transform: 'translateY(0px)',
              boxShadow: '0 1px 4px rgba(0, 0, 0, 0.08)',
            },
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: '-100%',
              width: '100%',
              height: '100%',
              background:
                'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent)',
              transition: 'left 0.6s',
            },
            '&:hover::before': {
              left: '100%',
            },
          }}
        >
          <ArrowBackIcon
            className="back-icon"
            sx={{
              fontSize: '18px',
              color: '#666',
              transition: 'all 0.3s ease',
            }}
          />
          <Typography
            className="back-text"
            sx={{
              fontFamily: 'Jost',
              fontSize: '14px',
              fontWeight: 600,
              color: '#333',
              transition: 'all 0.3s ease',
              letterSpacing: '0.3px',
            }}
          >
            Back to Cart
          </Typography>
        </Box>
      </Box>

      <Container
        maxWidth={'xl'}
        sx={{ paddingY: '20px', backgroundColor: '#fdfdfd' }}
      >
        <Grid container gap={3} marginX={'auto'} justifyContent={'center'}>
          <Grid item lg={7} sm={12}>
            <Box>
              <Box
                className={classes.flexRow}
                sx={{
                  width: '100%',
                  justifyContent: 'center',
                }}
              >
                {environment?.restaurantId !== 'fattyPattyDev' &&
                  environment?.restaurantId !== 'fattyPatty' && (
                    <Button
                      disableRipple={true}
                      disabled={
                        orderType === 'delivery' ||
                        orderType === 'noDriverDelivery'
                          ? orderType === 'Delivery'
                          : orderType === 'dinein'
                          ? orderType === 'dinein'
                          : orderType === 'pickup'
                      }
                      style={{
                        width: '100%',
                        cursor: 'default',
                        backgroundColor: environment.mainColor,
                        color: 'white',
                        fontSize: '18px',
                        fontWeight: 'bold',
                      }}
                      variant={'contained'}
                    >
                      {orderType === 'delivery' ||
                      orderType === 'noDriverDelivery'
                        ? t('confirmPage.Delivery')
                        : orderType === 'dinein'
                        ? t('confirmPage.Dinein')
                        : t('confirmPage.pickUp')}
                    </Button>
                  )}
                <Divider />
              </Box>

              <Stack
                sx={{
                  padding: '20px 10px',
                  gap: '1.5rem',
                  borderRadius: '16px',
                  backgroundColor: 'white',
                  boxShadow: '0px 0px 50px 0px #4545450D',
                }}
              >
                {/* Redeem Points section inserted above Shipping Address */}
                {!isAnonymous && (
                  <>
                    {isLoadingPoints ? (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          minHeight: '100px',
                          padding: '20px',
                          backgroundColor: '#f9f9f9',
                          borderRadius: '8px',
                          margin: '16px 0',
                        }}
                      >
                        <Snipper />
                        <Typography
                          variant="body2"
                          sx={{ marginLeft: '10px', color: '#666' }}
                        >
                          Loading rewards...
                        </Typography>
                      </Box>
                    ) : (
                      currentRedeemPoints > 0 && (
                        <RedeemPoints
                          balance={currentRedeemPoints}
                          offers={programOffers}
                          selectedOfferId={selectedOffer}
                          onSelectOffer={(id, selectedItemId = null) => {
                            setSelectedOffer(id);
                            // Store selectedItemId for use in the reward calculation
                            setSelectedRewardItemId(selectedItemId);
                          }}
                          onClearReward={async () => {
                            setSelectedOffer(null);
                            setSelectedRewardItemId(null);

                            // Recalculate price without reward - explicitly pass null values
                            const newPricingData =
                              await calculatePriceWithUpdates({
                                calculateType: 'price',
                                rewardTierId: null,
                                loyaltyAccountId: null,
                                rewardItemId: null,
                              });

                            // After reward is cleared, recalculate tip based on the new total if percentage tip is selected
                            if (newPricingData && typeTip !== 'other') {
                              const newTotal = newPricingData.total / 100;
                              let newTipAmount = 0;

                              // Recalculate based on which percentage is selected
                              if (typeTip === 'a') {
                                newTipAmount = Math.round(
                                  ((newTotal * 10) / 100) * 100
                                ); // 10% in cents
                              } else if (typeTip === 'b') {
                                newTipAmount = Math.round(
                                  ((newTotal * 15) / 100) * 100
                                ); // 15% in cents
                              } else if (typeTip === 'c') {
                                newTipAmount = Math.round(
                                  ((newTotal * 20) / 100) * 100
                                ); // 20% in cents
                              }

                              // Update tip amount state immediately so TipsBox displays correct values
                              setTipsAmount(newTipAmount);

                              // Only make another API call if the tip amount actually changed
                              if (Math.abs(newTipAmount - tipAmount) > 1) {
                                await calculatePriceWithUpdates({
                                  newTipAmount,
                                  rewardTierId: null,
                                  loyaltyAccountId: null,
                                });
                              }
                            }
                          }}
                          onCalculatePrice={handleRewardSelection}
                          apiPricingData={apiPricingData}
                          deliveryOrPickup={
                            orderType === 'delivery'
                              ? 'delivery'
                              : orderType || 'pickup'
                          }
                          deliveryId={effectiveDeliveryId}
                          storeId={storeId}
                          totalAmount={apiPricingData?.total}
                          tipAmount={tipAmount}
                          currentCartData={{
                            discount,
                            code,
                            isVerify: false,
                            typeAddress,
                            orderType,
                            storeId: storeIdD || storeId,
                          }}
                          setFreeItemDetailsData={setFreeItemDetailsData}
                          setFreeItemId={setFreeItemId}
                        />
                      )
                    )}
                  </>
                )}
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1.5,
                  }}
                >
                  {/* User Personal Information Section */}
                  {auth?.currentUser && !auth?.currentUser?.isAnonymous && (
                    <Box
                      sx={{
                        backgroundColor: 'white',
                        borderRadius: '16px',
                        padding: '18px',
                        border: '1px solid #E5E7EB',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                        '&:hover': {
                          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                          borderColor: `${environment.mainColor}30`,
                        },
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: 1.5,
                        }}
                      >
                        <Box
                          sx={{
                            width: '44px',
                            height: '44px',
                            minWidth: '44px',
                            borderRadius: '12px',
                            background: `linear-gradient(135deg, ${environment.mainColor}20, ${environment.mainColor}10)`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: `0 2px 8px ${environment.mainColor}15`,
                          }}
                        >
                          <PersonIcon
                            sx={{
                              color: environment.mainColor,
                              fontSize: '24px',
                            }}
                          />
                        </Box>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography
                            variant="subtitle2"
                            sx={{
                              fontWeight: '700',
                              color: '#172B4D',
                              fontSize: '17px',
                              fontFamily: 'Jost',
                              marginBottom: '8px',
                              letterSpacing: '-0.2px',
                            }}
                          >
                            Personal Information
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              color: '#172B4D',
                              fontWeight: 600,
                              fontFamily: 'Jost',
                              fontSize: '15px',
                              marginBottom: '4px',
                              lineHeight: 1.4,
                            }}
                          >
                            {user?.firstName && user?.lastName
                              ? `${user.firstName} ${user.lastName}`.trim()
                              : auth?.currentUser?.displayName ||
                                user?.displayName ||
                                'Customer'}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: '#6B7280',
                              fontFamily: 'Jost',
                              fontSize: '14px',
                              lineHeight: 1.5,
                              marginBottom: '2px',
                            }}
                          >
                            {personalEmail ||
                              user?.email ||
                              auth?.currentUser?.email ||
                              'No email provided'}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: '#6B7280',
                              fontFamily: 'Jost',
                              fontSize: '14px',
                              lineHeight: 1.5,
                            }}
                          >
                            {(() => {
                              const raw =
                                personalPhone ||
                                user?.phoneNumber ||
                                auth?.currentUser?.phoneNumber;
                              if (!raw) return 'No phone provided';

                              // Ensure we have a country code (E.164) when possible.
                              // `formatPhoneNumber` expects an E.164 value like +14155552671.
                              const s = String(raw).trim();
                              const digits = s.replace(/[^\d]/g, '');
                              const e164 =
                                s.startsWith('+')
                                  ? s
                                  : digits.length === 10
                                    ? `+1${digits}` // assume US local number
                                    : digits.length === 11 && digits.startsWith('1')
                                      ? `+${digits}` // already includes US country code without '+'
                                      : s;

                              const formatted = formatPhoneNumber(e164);
                              return formatted || e164;
                            })()}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  )}

                  {/* Delivery/Pickup Address Section */}
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      borderRadius: '16px',
                      padding: '18px',
                      border: '1px solid #E5E7EB',
                      transition: 'all 0.2s ease',
                      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                      '&:hover': {
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                        borderColor: `${environment.mainColor}30`,
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.5,
                      }}
                    >
                      <Box
                        sx={{
                          width: '44px',
                          height: '44px',
                          minWidth: '44px',
                          borderRadius: '12px',
                          background: `linear-gradient(135deg, ${environment.mainColor}20, ${environment.mainColor}10)`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          boxShadow: `0 2px 8px ${environment.mainColor}15`,
                        }}
                      >
                        {orderType === 'delivery' ||
                        orderType === 'noDriverDelivery' ? (
                          <LocalShippingIcon
                            sx={{
                              color: environment.mainColor,
                              fontSize: '24px',
                            }}
                          />
                        ) : (
                          <StorefrontIcon
                            sx={{
                              color: environment.mainColor,
                              fontSize: '24px',
                            }}
                          />
                        )}
                      </Box>
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                          variant="subtitle2"
                          sx={{
                            fontWeight: '700',
                            color: '#172B4D',
                            fontSize: '17px',
                            fontFamily: 'Jost',
                            marginBottom: '8px',
                            letterSpacing: '-0.2px',
                          }}
                        >
                          {orderType === 'delivery' ||
                          orderType === 'noDriverDelivery'
                            ? 'Delivery Address'
                            : t('confirmPage.pickupAddress')}
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            color: '#172B4D',
                            fontWeight: 600,
                            fontFamily: 'Jost',
                            fontSize: '15px',
                            marginBottom: '4px',
                            lineHeight: 1.4,
                          }}
                        >
                          {orderType === 'delivery' ||
                          orderType === 'noDriverDelivery'
                            ? effectiveDeliveryAddress
                            : filteredStore?.restaurant_name || defaultStore}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: '#6B7280',
                            fontFamily: 'Jost',
                            fontSize: '14px',
                            lineHeight: 1.5,
                            marginBottom: '4px',
                          }}
                        >
                          {orderType === 'delivery' ||
                          orderType === 'noDriverDelivery'
                            ? defauldAdd
                            : storeAddressDetails}
                        </Typography>
                        {(orderType !== 'delivery' &&
                          orderType !== 'noDriverDelivery' &&
                          filteredStore?.contact_number_1) && (
                          <Typography
                            variant="body2"
                            sx={{
                              color: '#6B7280',
                              fontFamily: 'Jost',
                              fontSize: '14px',
                              lineHeight: 1.5,
                            }}
                          >
                            {filteredStore.contact_number_1}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </Box>

                  {/* Branch Information Section (for delivery only) */}
                  {(orderType === 'delivery' ||
                    orderType === 'noDriverDelivery') && (
                    <Box
                      sx={{
                        backgroundColor: 'white',
                        borderRadius: '16px',
                        padding: '18px',
                        border: '1px solid #E5E7EB',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                        '&:hover': {
                          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                          borderColor: `${environment.mainColor}30`,
                        },
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: 1.5,
                        }}
                      >
                        <Box
                          sx={{
                            width: '44px',
                            height: '44px',
                            minWidth: '44px',
                            borderRadius: '12px',
                            background: `linear-gradient(135deg, ${environment.mainColor}20, ${environment.mainColor}10)`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: `0 2px 8px ${environment.mainColor}15`,
                          }}
                        >
                          <StorefrontIcon
                            sx={{
                              color: environment.mainColor,
                              fontSize: '24px',
                            }}
                          />
                        </Box>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography
                            variant="subtitle2"
                            sx={{
                              fontWeight: '700',
                              color: '#172B4D',
                              fontSize: '17px',
                              fontFamily: 'Jost',
                              marginBottom: '8px',
                              letterSpacing: '-0.2px',
                            }}
                          >
                            Branch Information
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              color: '#172B4D',
                              fontWeight: 600,
                              fontFamily: 'Jost',
                              fontSize: '15px',
                              marginBottom: '4px',
                              lineHeight: 1.4,
                            }}
                          >
                            {filteredStore?.restaurant_name || filteredStore?.businessName}
                          </Typography>
                          {filteredStore && (
                            <Typography
                              variant="body2"
                              sx={{
                                color: '#6B7280',
                                fontFamily: 'Jost',
                                fontSize: '14px',
                                lineHeight: 1.5,
                              }}
                            >
                              {(() => {
                                const addr =
                                  filteredStore?.address ||
                                  filteredStore?.location;

                                if (
                                  typeof addr === 'string' &&
                                  addr.trim().length > 0
                                ) {
                                  return addr;
                                }

                                if (addr && typeof addr === 'object') {
                                  if (
                                    addr.displayName &&
                                    addr.displayName.trim()
                                  ) {
                                    return addr.displayName.trim();
                                  }

                                  const parts = [];
                                  if (
                                    addr.addressLine1 &&
                                    addr.addressLine1.trim()
                                  ) {
                                    parts.push(addr.addressLine1.trim());
                                  }
                                  if (
                                    addr.addressLine2 &&
                                    addr.addressLine2.trim()
                                  ) {
                                    parts.push(addr.addressLine2.trim());
                                  }

                                  const cityPart =
                                    (addr.city && addr.city.trim()) ||
                                    (addr.locality && addr.locality.trim());

                                  const statePart =
                                    (addr.state && addr.state.trim()) ||
                                    (addr.administrativeDistrictLevel1 &&
                                      addr.administrativeDistrictLevel1.trim());

                                  const zipPart =
                                    (addr.zipCode && addr.zipCode.trim()) ||
                                    (addr.postalCode && addr.postalCode.trim());

                                  const cityStateZip = [
                                    cityPart,
                                    statePart,
                                    zipPart,
                                  ]
                                    .filter(Boolean)
                                    .join(', ');

                                  if (cityStateZip) parts.push(cityStateZip);

                                  if (parts.length === 0) {
                                    const routeParts = [];
                                    if (
                                      addr.streetNumber &&
                                      addr.streetNumber.trim()
                                    ) {
                                      routeParts.push(addr.streetNumber.trim());
                                    }
                                    if (addr.route && addr.route.trim()) {
                                      routeParts.push(addr.route.trim());
                                    }
                                    if (routeParts.length)
                                      parts.push(routeParts.join(' '));
                                  }

                                  if (parts.length > 0)
                                    return parts.join(' • ');
                                }

                                return 'Address not available';
                              })()}
                            </Typography>
                          )}
                          {filteredStore?.contact_number_1 && (
                            <Typography
                              variant="body2"
                              sx={{
                                color: '#6B7280',
                                fontFamily: 'Jost',
                                fontSize: '14px',
                                lineHeight: 1.5,
                                marginTop: '4px',
                              }}
                            >
                              {filteredStore.contact_number_1}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  )}
                </Box>

                {environment?.restaurantId !== 'fattyPattyDev' &&
                  environment?.restaurantId !== 'fattyPatty' && (
                    <Divider style={{ marginTop: '50px' }} />
                  )}

                {/* Personal Info Section */}
                {/* Personal Info Section - ONLY for anonymous users during signup */}
                {isAnonymous && (
                  <Grid
                    item
                    sm={12}
                    lg={12}
                    bgcolor={'#FAFAFA'}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      borderRadius: '8px',
                      padding: '10px 20px',
                      marginTop: '24px',
                    }}
                  >
                    <div data-section="personal-info">
                      <Typography
                        component="p"
                        variant="h6"
                        sx={{
                          fontWeight: '700',
                          color: '#172B4D',
                          fontSize: '20px',
                          fontFamily: 'Jost',
                          marginBottom: '10px',
                        }}
                      >
                        Personal Info
                      </Typography>

                      {emailConfirmed && (
                        <Box
                          sx={{
                            mb: 2,
                            p: 1.5,
                            borderRadius: '10px',
                            backgroundColor: '#ECFDF3',
                            border: '1px solid #22C55E',
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: 'Jost, sans-serif',
                              fontSize: '13px',
                              fontWeight: 500,
                              color: '#166534',
                            }}
                          >
                            Personal information confirmed successfully.
                          </Typography>
                        </Box>
                      )}
                      <Grid container spacing={2}>
                        {/* Phone first */}
                        <Grid item xs={12}>
                          <div
                            style={{
                              backgroundColor: 'white',
                              borderRadius: '10px',
                            }}
                          >
                            <PhoneInternational
                              phoneNumber={personalPhone}
                              setPhoneNumber={(val) => {
                                setPersonalPhone(val);
                                // Reset email and name auto-fill state when phone changes
                                if (isEmailAutoFilled) {
                                  setIsEmailAutoFilled(false);
                                  setIsEmailLocked(false);
                                  setRegisteredPhoneEmail(null);
                                }
                                if (
                                  isFirstNameAutoFilled ||
                                  isLastNameAutoFilled
                                ) {
                                  setIsFirstNameAutoFilled(false);
                                  setIsLastNameAutoFilled(false);
                                  setIsNamesLocked(false);
                                  setRegisteredPhoneNames(null);
                                }
                                if (val) {
                                  setPersonalErrors((p) => ({
                                    ...p,
                                    phone: '',
                                  }));
                                }
                              }}
                              onBlur={async () => {
                                if (
                                  !personalPhone ||
                                  !isValidPhoneNumber(personalPhone)
                                ) {
                                  setPersonalErrors((p) => ({
                                    ...p,
                                    phone: 'Please enter a valid phone number',
                                  }));
                                  return;
                                }

                                // Clear phone error
                                setPersonalErrors((p) => ({
                                  ...p,
                                  phone: '',
                                }));

                                // Automatically trigger OTP when valid phone is entered
                                if (!verifiedNum && !isPhoneVerification) {
                                  requestOTP();
                                }
                              }}
                              placeholder={'Phone Number'}
                              error={!!personalErrors.phone}
                              backgroundColor={'white'}
                              borderRadius={'10px'}
                            />
                          </div>
                          {personalErrors.phone && (
                            <Typography variant="caption" color="error">
                              {personalErrors.phone}
                            </Typography>
                          )}
                        </Grid>
                        {/* First Name */}
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label={'First Name'}
                            value={personalFirstName}
                            required
                            disabled={!verifiedNum}
                            onChange={(e) => {
                              setPersonalFirstName(e.target.value);
                              if (
                                e.target.value &&
                                e.target.value.trim().length >= 2
                              ) {
                                setPersonalErrors((p) => ({
                                  ...p,
                                  firstName: '',
                                }));
                              }
                            }}
                            onBlur={() => {
                              const value = (personalFirstName || '').trim();
                              const error =
                                !value || value.length < 2
                                  ? 'Please enter your first name'
                                  : '';
                              setPersonalErrors((p) => ({
                                ...p,
                                firstName: error,
                              }));
                            }}
                            error={!!personalErrors.firstName}
                            helperText={personalErrors.firstName}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                backgroundColor: verifiedNum
                                  ? 'white'
                                  : '#f5f5f5',
                                borderRadius: '10px',
                              },
                            }}
                          />
                        </Grid>
                        {/* Last Name */}
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label={'Last Name'}
                            value={personalLastName}
                            required
                            disabled={!verifiedNum}
                            onChange={(e) => {
                              setPersonalLastName(e.target.value);
                              if (
                                e.target.value &&
                                e.target.value.trim().length >= 2
                              ) {
                                setPersonalErrors((p) => ({
                                  ...p,
                                  lastName: '',
                                }));
                              }
                            }}
                            onBlur={() => {
                              const value = (personalLastName || '').trim();
                              const error =
                                !value || value.length < 2
                                  ? 'Please enter your last name'
                                  : '';
                              setPersonalErrors((p) => ({
                                ...p,
                                lastName: error,
                              }));
                            }}
                            error={!!personalErrors.lastName}
                            helperText={personalErrors.lastName}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                backgroundColor: verifiedNum
                                  ? 'white'
                                  : '#f5f5f5',
                                borderRadius: '10px',
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label={'Email Address'}
                            value={personalEmail}
                            required
                            disabled={
                              !verifiedNum || isCheckingEmail || emailConfirmed
                            }
                            onChange={(e) => {
                              setPersonalEmail(e.target.value);
                              // Clear error immediately on change
                              setPersonalErrors((p) => ({ ...p, email: '' }));
                              // Trigger debounced validation
                              validateEmailWithDebounce(e.target.value);
                            }}
                            onBlur={async () => {
                              // Email validation is now handled by debounced function
                              // Keep onBlur for legacy phone-email consistency check
                              const value = (personalEmail || '').trim();
                              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                              if (!emailRegex.test(value)) {
                                return; // Already handled by debounced validation
                              }

                              const normalizedInputEmail = value
                                .toLowerCase()
                                .trim();

                              // If this is the registered phone-email pair, allow it
                              if (
                                registeredPhoneEmail &&
                                registeredPhoneEmail.phone === personalPhone &&
                                registeredPhoneEmail.email ===
                                  normalizedInputEmail
                              ) {
                                setPersonalErrors((p) => ({ ...p, email: '' }));
                                return;
                              }

                              // Phone-email consistency check (only if validation passed)
                              if (
                                !personalErrors.email &&
                                personalPhone &&
                                isValidPhoneNumber(personalPhone)
                              ) {
                                const phoneData = await checkPhoneNumberExists(
                                  personalPhone
                                );
                                if (
                                  phoneData &&
                                  phoneData.exists &&
                                  phoneData.email
                                ) {
                                  if (
                                    phoneData.email === normalizedInputEmail
                                  ) {
                                    // Email matches registered phone - allowed
                                    setPersonalErrors((p) => ({
                                      ...p,
                                      email: '',
                                    }));
                                  } else {
                                    // Phone registered with different email
                                    setPersonalErrors((p) => ({
                                      ...p,
                                      email:
                                        'This phone number is already registered with a different email',
                                    }));
                                  }
                                }
                              }
                            }}
                            error={!!personalErrors.email}
                            helperText={
                              isCheckingEmail
                                ? 'Checking email availability...'
                                : personalErrors.email
                            }
                            InputProps={{
                              endAdornment: isCheckingEmail ? (
                                <InputAdornment position="end">
                                  <CircularProgress size={20} />
                                </InputAdornment>
                              ) : null,
                            }}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                backgroundColor:
                                  verifiedNum && !emailConfirmed
                                    ? 'white'
                                    : '#f5f5f5',
                                borderRadius: '10px',
                              },
                            }}
                          />
                          {personalErrors.email ===
                            'This email is already registered' && (
                            <Button
                              variant="contained"
                              onClick={() => {
                                window.location.href = '/signup';
                              }}
                              sx={{
                                marginTop: '8px',
                                textTransform: 'none',
                                backgroundColor: environment.mainColor,
                                color: 'white',
                                fontFamily: 'Jost',
                                fontWeight: 600,
                                fontSize: '14px',
                                padding: '10px 24px',
                                borderRadius: '10px',
                                boxShadow: 'none',
                                '&:hover': {
                                  backgroundColor: environment.mainColor,
                                  opacity: 0.9,
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                },
                              }}
                            >
                              Login to Continue
                            </Button>
                          )}
                        </Grid>

                        {/* OTP Verification moved to dialog */}
                      </Grid>
                    </div>
                    {/* Disclaimers inside Personal Info section */}
                    {isAnonymous ? (
                      <Box sx={{ mt: 2 }}>
                        <Typography
                          variant="body2"
                          sx={{ color: '#4B5563', fontFamily: 'Jost', mb: 1 }}
                        >
                          By creating an account or placing an order, you’ll
                          automatically be enrolled in our Fatty Patty Rewards
                          Program
                        </Typography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={marketingOptIn}
                              onChange={(e) =>
                                setMarketingOptIn(e.target.checked)
                              }
                              sx={{
                                color: 'rgb(253, 86, 34)',
                                '&.Mui-checked': { color: 'rgb(253, 86, 34)' },
                              }}
                            />
                          }
                          label="Yes, I want to receive news, promotions, and special offers by email or text"
                        />
                      </Box>
                    ) : (
                      ''
                    )}
                  </Grid>
                )}

                {environment?.restaurantId !== 'fattyPattyDev' &&
                  environment?.restaurantId !== 'fattyPatty' && (
                    <Divider style={{ marginTop: '50px' }} />
                  )}

                <Grid item xs={12}>
                  {!unavailableNow && (
                    <Box
                      bgcolor={'#FAFAFA'}
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        borderRadius: '8px',
                        padding: '10px 20px',
                      }}
                    >
                      {' '}
                      <Typography
                        component="p"
                        variant="h6"
                        sx={{
                          fontWeight: '700',
                          color: '#172B4D',
                          fontSize: '20px',
                          fontFamily: 'Jost',
                          marginBottom: '10px',
                          textTransform: 'capitalize',
                        }}
                      >
                        {orderType === 'delivery' || orderType === 'noDriverDelivery' ? 'Delivery Time' : 'Pickup Time'}
                      </Typography>
                      <Box sx={{ width: '100%' }}>
                        <div
                          className={classes.flexFullWidth}
                          style={{
                            display: 'grid',
                            gridTemplateColumns: smDown ? '1fr' : '1fr 1fr',
                            gap: '10px',
                            margin: 0,
                          }}
                        >
                          {!hasCatering && (
                            <div
                              className={classes.flexRow}
                              style={{
                                gridColumn: 'span 1', // Ensures this div takes one column in grid layout
                                marginBottom: smDown ? '10px' : '0',
                              }}
                            >
                              <Stack
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                className={classes.flexRow}
                                sx={{
                                  paddingLeft: '10px',
                                  borderRadius: '10px',
                                  width: '100%',
                                  backgroundColor: 'white',
                                  padding: '12px 25px',
                                }}
                              >
                                <Stack
                                  direction="row"
                                  gap={3}
                                  alignItems="center"
                                  className={classes.flexRow}
                                >
                                  <div>
                                    <LocalShippingIcon
                                      fontSize="large"
                                      style={{ color: environment.mainColor }}
                                    />
                                  </div>
                                  <div>
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        fontFamily: 'Jost',
                                        color: '#172B4D',
                                        fontWeight: 600,
                                      }}
                                    >
                                      {t('confirmPage.asap')} <br />
                                      <span
                                        style={{
                                          color: '#4F4F4F',
                                          fontFamily: 'Jost',
                                          fontWeight: 400,
                                          fontSize: '14px',
                                        }}
                                      >
                                        {unavailableNow || !slots?.asap
                                          ? stateTxt
                                          : asap}
                                      </span>
                                    </Typography>
                                  </div>
                                </Stack>
                                {!unavailableNow && slots?.asap ? (
                                  <Radio
                                    checked={selectedValue === 'a'}
                                    sx={{
                                      color: environment.mainColor,
                                      '&.Mui-checked': {
                                        color: environment.mainColor,
                                      },
                                    }}
                                    onChange={(event) => {
                                      handleChange(event);
                                    }}
                                    value="a"
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'A' }}
                                  />
                                ) : (
                                  <div style={{ width: 50 }} />
                                )}
                              </Stack>
                            </div>
                          )}

                          <Stack
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            className={classes.flexRow}
                            sx={{
                              gridColumn: 'span 1',
                              backgroundColor: 'white',
                              padding: '12px 25px',
                              borderRadius: '12px',
                            }}
                          >
                            <Stack
                              direction="row"
                              gap={3}
                              alignItems="center"
                              sx={{
                                backgroundColor: 'white',
                              }}
                            >
                              <div>
                                <IoTime
                                  size={24}
                                  style={{ color: environment.mainColor }}
                                />
                              </div>
                              <div>
                                <Typography
                                  variant="body1"
                                  onClick={
                                    selectedValue === 'b'
                                      ? handleClickOpen
                                      : undefined
                                  }
                                  sx={{
                                    cursor: 'pointer',
                                    padding: '3px',
                                    color: '#172B4D',
                                    fontFamily: 'Jost',
                                    fontWeight: 600,
                                  }}
                                >
                                  {t('confirmPage.Schedulerforlater')} <br />
                                  <span
                                    style={{
                                      color: '#4F4F4F',
                                      fontFamily: 'Jost',
                                      fontWeight: 400,
                                      fontSize: '14px',
                                    }}
                                  >
                                    {selectedTime.data
                                      ? `${
                                          realTime === 'today'
                                            ? 'Today'
                                            : realTime === 'tomorrow'
                                            ? 'Tomorrow'
                                            : i18n.language === 'ar'
                                            ? getTomorrow().after.dayInArabic
                                            : getTomorrow().after.day +
                                              ', ' +
                                              getTomorrowScheduleLater()
                                        }: ${formatTimeTo12Hour(
                                          selectedTime.data
                                        )}`
                                      : `${t('confirmPage.pleaseChooseTime')}`}
                                  </span>
                                </Typography>
                                <Dialog
                                  onClose={handleClose}
                                  open={open}
                                  fullWidth={smDown}
                                  maxWidth="md"
                                  PaperProps={{
                                    style: {
                                      borderRadius: '24px',
                                      boxShadow:
                                        '0px 20px 60px rgba(0, 0, 0, 0.15)',
                                      border: 'none',
                                      overflow: 'hidden',
                                      background: 'white',
                                      minHeight: '500px',
                                    },
                                  }}
                                >
                                  <div
                                    style={{
                                      position: 'absolute',
                                      top: '16px',
                                      right: '16px',
                                      zIndex: 1000,
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: '40px',
                                        height: '40px',
                                        borderRadius: '50%',
                                        backgroundColor: '#f5f5f5',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        '&:hover': {
                                          backgroundColor: '#e0e0e0',
                                          transform: 'scale(1.05)',
                                        },
                                      }}
                                      onClick={handleClose}
                                      sx={{
                                        '&:hover': {
                                          backgroundColor: '#e0e0e0 !important',
                                          transform: 'scale(1.05)',
                                        },
                                      }}
                                    >
                                      <CancelRoundedIcon
                                        style={{
                                          cursor: 'pointer',
                                          color: '#666666',
                                          fontSize: '20px',
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <DialogTitle
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      padding: '32px 24px 16px 24px',
                                      background: `linear-gradient(135deg, ${environment.mainColor}15, ${environment.mainColor}08)`,
                                      borderBottom: `2px solid ${environment.mainColor}20`,
                                      textAlign: 'center',
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: '64px',
                                        height: '64px',
                                        backgroundColor: environment.mainColor,
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginBottom: '16px',
                                        boxShadow: `0px 8px 24px ${environment.mainColor}40`,
                                      }}
                                    >
                                      <IoTime
                                        size={28}
                                        style={{ color: 'white' }}
                                      />
                                    </div>
                                    <Typography
                                      component="h2"
                                      variant="h5"
                                      style={{
                                        fontWeight: '700',
                                        color: '#1a1a1a',
                                        fontSize: '24px',
                                        fontFamily: 'Jost, sans-serif',
                                        marginBottom: '8px',
                                        letterSpacing: '-0.5px',
                                      }}
                                    >
                                      {t('confirmPage.Schedulerforlater')}
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      style={{
                                        color: '#666666',
                                        fontSize: '14px',
                                        fontFamily: 'Jost, sans-serif',
                                        maxWidth: '280px',
                                        lineHeight: '1.5',
                                      }}
                                    >
                                      Choose your preferred date and time for
                                      delivery
                                    </Typography>
                                  </DialogTitle>
                                  <DialogContent
                                    style={{
                                      padding: '24px 32px 32px 32px',
                                      backgroundColor: '#fafafa',
                                      borderTop: 'none',
                                      borderBottom: 'none',
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'column',

                                        gap: '4px',
                                        minHeight: '320px',
                                      }}
                                    >
                                      <div
                                        style={{
                                          flex: 1,
                                          display: 'flex',
                                          flexDirection: 'column',
                                          gap: '12px',
                                          width: '100%',
                                          alignItems: 'stretch',
                                          marginRight: !smDown ? '24px' : '0px',
                                          marginBottom: smDown ? '24px' : '0px',
                                          padding: '16px',
                                          backgroundColor: 'white',
                                          borderRadius: '16px',
                                          boxShadow:
                                            '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                        }}
                                      >
                                        <Typography
                                          variant="h6"
                                          style={{
                                            fontSize: '16px',
                                            fontWeight: '600',
                                            color: '#333333',

                                            fontFamily: 'Jost, sans-serif',
                                            textAlign: smDown
                                              ? 'center'
                                              : 'left',
                                          }}
                                        >
                                          Select Date
                                        </Typography>
                                        <Stack
                                          flexDirection="row"
                                          alignItems="center"
                                          justifyContent="center"
                                          gap={1}
                                        >
                                          {!hasCatering && (
                                            <Button
                                              disableRipple={true}
                                              style={{
                                                width: '100%',
                                                height: '64px',
                                                backgroundColor:
                                                  sendTime === today
                                                    ? environment.mainColor
                                                    : 'transparent',
                                                color:
                                                  sendTime === today
                                                    ? 'white'
                                                    : '#666666',
                                                border:
                                                  sendTime === today
                                                    ? 'none'
                                                    : '2px solid #e0e0e0',
                                                borderRadius: '12px',
                                                fontWeight: '600',
                                                fontSize: '14px',
                                                fontFamily: 'Jost, sans-serif',
                                                textTransform: 'none',
                                                boxShadow:
                                                  sendTime === today
                                                    ? `0px 4px 12px ${environment.mainColor}40`
                                                    : 'none',
                                                transition: 'all 0.2s ease',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '4px',
                                              }}
                                              variant="contained"
                                              sx={{
                                                '&:hover':
                                                  sendTime !== today
                                                    ? {
                                                        backgroundColor:
                                                          '#f5f5f5 !important',
                                                        transform:
                                                          'translateY(-1px)',
                                                        borderColor:
                                                          environment.mainColor,
                                                      }
                                                    : {},
                                              }}
                                              onClick={() => {
                                                setSendTime(today);
                                              }}
                                            >
                                              <span
                                                style={{
                                                  fontSize: '14px',
                                                  fontWeight: '600',
                                                }}
                                              >
                                                {t('confirmPage.today')}
                                              </span>
                                              <span
                                                style={{
                                                  fontSize: '12px',
                                                  fontWeight: '500',
                                                  opacity:
                                                    sendTime === today
                                                      ? 0.9
                                                      : 0.7,
                                                }}
                                              >
                                                {todayLabelInline}
                                              </span>
                                            </Button>
                                          )}
                                          <Button
                                            disableRipple={true}
                                            style={{
                                              width: '100%',
                                              height: '64px',
                                              backgroundColor:
                                                sendTime === tomorrow
                                                  ? environment.mainColor
                                                  : 'transparent',
                                              color:
                                                sendTime === tomorrow
                                                  ? 'white'
                                                  : '#666666',
                                              border:
                                                sendTime === tomorrow
                                                  ? 'none'
                                                  : '2px solid #e0e0e0',
                                              borderRadius: '12px',
                                              fontWeight: '600',
                                              fontSize: '14px',
                                              fontFamily: 'Jost, sans-serif',
                                              textTransform: 'none',
                                              boxShadow:
                                                sendTime === tomorrow
                                                  ? `0px 4px 12px ${environment.mainColor}40`
                                                  : 'none',
                                              transition: 'all 0.2s ease',
                                              display: 'flex',
                                              flexDirection: 'column',
                                              gap: '4px',
                                            }}
                                            variant="contained"
                                            sx={{
                                              '&:hover':
                                                sendTime !== tomorrow
                                                  ? {
                                                      backgroundColor:
                                                        '#f5f5f5 !important',
                                                      transform:
                                                        'translateY(-1px)',
                                                      borderColor:
                                                        environment.mainColor,
                                                    }
                                                  : {},
                                            }}
                                            onClick={() => {
                                              setSendTime(tomorrow);
                                            }}
                                          >
                                            <span
                                              style={{
                                                fontSize: '14px',
                                                fontWeight: '600',
                                              }}
                                            >
                                              {t('confirmPage.tomorrow')}
                                            </span>
                                            <span
                                              style={{
                                                fontSize: '12px',
                                                fontWeight: '500',
                                                opacity:
                                                  sendTime === tomorrow
                                                    ? 0.9
                                                    : 0.7,
                                              }}
                                            >
                                              {tomorrowLabelInline}
                                            </span>
                                          </Button>
                                        </Stack>

                                        {/* <Button
                                          disableRipple={true}
                                          style={{
                                            width: '100%',
                                            height: '48px',
                                            backgroundColor:
                                              sendTime === afterTomorrow
                                                ? environment.mainColor
                                                : 'transparent',
                                            color:
                                              sendTime === afterTomorrow
                                                ? 'white'
                                                : '#666666',
                                            border:
                                              sendTime === afterTomorrow
                                                ? 'none'
                                                : '2px solid #e0e0e0',
                                            borderRadius: '12px',
                                            fontWeight: '600',
                                            fontSize: '14px',
                                            fontFamily: 'Jost, sans-serif',
                                            textTransform: 'none',
                                            boxShadow:
                                              sendTime === afterTomorrow
                                                ? `0px 4px 12px ${environment.mainColor}40`
                                                : 'none',
                                            transition: 'all 0.2s ease',
                                          }}
                                          variant="contained"
                                          sx={{
                                            '&:hover': sendTime !== afterTomorrow ? {
                                              backgroundColor: '#f5f5f5 !important',
                                              transform: 'translateY(-1px)',
                                              borderColor: environment.mainColor,
                                            } : {},
                                          }}
                                          onClick={() => {
                                            setSendTime(afterTomorrow);
                                          }}
                                        >
                                          {i18n.language === 'ar'
                                            ? getTomorrow().after.dayInArabic
                                            : getTomorrow().after.day +
                                              ', ' +
                                              getTomorrowScheduleLater()}
                                        </Button> */}
                                      </div>
                                      <div
                                        style={{
                                          flex: 1,
                                          width: '100%',
                                          padding: '16px',
                                          backgroundColor: 'white',
                                          borderRadius: '16px',
                                          boxShadow:
                                            '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                        }}
                                      >
                                        <Typography
                                          variant="h6"
                                          style={{
                                            fontSize: '16px',
                                            fontWeight: '600',
                                            color: '#333333',
                                            marginBottom: '4px',
                                            fontFamily: 'Jost, sans-serif',
                                          }}
                                        >
                                          Available Time Slots For Pickup
                                        </Typography>
                                        {hasItemAvailabilityConstraints && (
                                          <Typography
                                            variant="body2"
                                            sx={{
                                              color: '#6B7280',
                                              fontSize: '12px',
                                              maxWidth: '100%',
                                              marginBottom: '8px',
                                              fontFamily: 'Jost, sans-serif',
                                            }}
                                          >
                                            {availabilityCategoryNames.length
                                              ? `Some items in your cart from ${availabilityCategoryNames.join(
                                                  ', '
                                                )} are only available during specific time windows. Time slots outside those windows have been hidden.`
                                              : 'Some items in your cart are only available during specific time windows. Time slots outside those windows have been hidden.'}
                                          </Typography>
                                        )}
                                        {slots && slots[sendTime]?.length ? (
                                          <div
                                            style={{
                                              display: 'grid',
                                              gridTemplateColumns:
                                                'repeat(auto-fit, minmax(140px, 1fr))',
                                              gap: '8px',
                                              maxHeight: '240px',
                                              overflowY: 'auto',
                                              padding: '4px',
                                            }}
                                          >
                                            {slots[sendTime].map(
                                              (item, index) => {
                                                const isSelected =
                                                  range === index &&
                                                  sendTime === prev;

                                                // Helper: always display time in 12-hour AM/PM format
                                                const formatSingleTime = (
                                                  time
                                                ) => {
                                                  if (
                                                    !time ||
                                                    typeof time !== 'string'
                                                  )
                                                    return time;
                                                  const t = time.trim();
                                                  const hasPeriod =
                                                    /AM|PM/i.test(t);
                                                  if (hasPeriod) {
                                                    const m = t.match(
                                                      /^(\d{1,2}):(\d{1,2})(?::\d{1,2})?\s*(AM|PM)$/i
                                                    );
                                                    if (m) {
                                                      const min = String(
                                                        parseInt(m[2], 10) || 0
                                                      ).padStart(2, '0');
                                                      return `${parseInt(
                                                        m[1],
                                                        10
                                                      )}:${min} ${m[3].toUpperCase()}`;
                                                    }
                                                  }
                                                  const parts = t.split(':');
                                                  let hour = parseInt(
                                                    parts[0],
                                                    10
                                                  );
                                                  const minStr = (
                                                    parts[1] || '00'
                                                  ).replace(/\s*[AP]M$/i, '');
                                                  const minute = String(
                                                    parseInt(minStr, 10) || 0
                                                  ).padStart(2, '0');
                                                  if (isNaN(hour)) return t;
                                                  const period =
                                                    hour >= 12 ? 'PM' : 'AM';
                                                  hour = hour % 12 || 12;
                                                  return `${hour}:${minute} ${period}`;
                                                };

                                                const formatTimeWithAMPM = (
                                                  timeStr
                                                ) => {
                                                  if (!timeStr) return timeStr;
                                                  if (timeStr.includes(' - ')) {
                                                    const [start, end] =
                                                      timeStr.split(' - ');
                                                    return `${formatSingleTime(
                                                      start.trim()
                                                    )} - ${formatSingleTime(
                                                      end.trim()
                                                    )}`;
                                                  }
                                                  return formatSingleTime(
                                                    timeStr
                                                  );
                                                };

                                                const displayTime =
                                                  formatTimeWithAMPM(item);

                                                return (
                                                  <Button
                                                    key={index + 'ty'}
                                                    disableRipple={true}
                                                    style={{
                                                      height: '44px',
                                                      backgroundColor:
                                                        isSelected
                                                          ? environment.mainColor
                                                          : 'transparent',
                                                      color: isSelected
                                                        ? 'white'
                                                        : '#333333',
                                                      border: isSelected
                                                        ? 'none'
                                                        : '2px solid #e0e0e0',
                                                      borderRadius: '8px',
                                                      fontSize: '13px',
                                                      fontWeight: '500',
                                                      fontFamily:
                                                        'Jost, sans-serif',
                                                      textTransform: 'none',
                                                      boxShadow: isSelected
                                                        ? `0px 4px 12px ${environment.mainColor}40`
                                                        : 'none',
                                                      transition:
                                                        'all 0.2s ease',
                                                    }}
                                                    variant="contained"
                                                    sx={{
                                                      '&:hover': !isSelected
                                                        ? {
                                                            backgroundColor:
                                                              '#f5f5f5 !important',
                                                            borderColor: `${environment.mainColor} !important`,
                                                            transform:
                                                              'translateY(-1px)',
                                                          }
                                                        : {},
                                                    }}
                                                    onClick={() => {
                                                      onTimeSelected(
                                                        item,
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    {displayTime}
                                                  </Button>
                                                );
                                              }
                                            )}
                                          </div>
                                        ) : (
                                          <div
                                            style={{
                                              display: 'flex',
                                              flexDirection: 'column',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                              padding: '32px 16px',
                                              textAlign: 'center',
                                            }}
                                          >
                                            <div
                                              style={{
                                                width: '48px',
                                                height: '48px',
                                                backgroundColor: '#f5f5f5',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginBottom: '12px',
                                              }}
                                            >
                                              <IoTime
                                                size={20}
                                                style={{ color: '#999999' }}
                                              />
                                            </div>
                                            <Typography
                                              style={{
                                                fontSize: '14px',
                                                color: '#666666',
                                                fontFamily: 'Jost, sans-serif',
                                                fontWeight: '500',
                                              }}
                                            >
                                              {hasItemAvailabilityConstraints ||
                                              lastAvailabilityCategoryNamesRef
                                                .current?.length > 0
                                                ? (() => {
                                                    const names =
                                                      availabilityCategoryNames.length >
                                                      0
                                                        ? availabilityCategoryNames
                                                        : lastAvailabilityCategoryNamesRef.current ||
                                                          [];
                                                    return names.length
                                                      ? `Items from ${names.join(
                                                          ', '
                                                        )} are not available at any time on this day at this branch. Please choose another day or branch, or remove these items from your cart.`
                                                      : 'Some items in your cart are not available at any time on this day at this branch. Please choose another day or branch, or remove these items from your cart.';
                                                  })()
                                                : sendTime === 'today'
                                                ? t('confirmPage.nohourstoday')
                                                : t('confirmPage.OffThisDay')}
                                            </Typography>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </DialogContent>
                                </Dialog>
                              </div>
                            </Stack>
                            {!unavailableNow && (
                              <Radio
                                checked={selectedValue === 'b'}
                                sx={{
                                  color: environment.mainColor,
                                  '&.Mui-checked': {
                                    color: environment.mainColor,
                                  },
                                }}
                                onChange={handleChange}
                                onClick={handleClickOpen}
                                value="b"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'B' }}
                              />
                            )}
                          </Stack>
                          {selectedTime.data &&
                            selectedValue === 'b' &&
                            (orderType === 'delivery' ||
                              orderType === 'noDriverDelivery') && (
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'flex-start',
                                  gap: '8px',
                                  marginTop: '12px',
                                  padding: '12px 14px',
                                  backgroundColor: '#FEF3C7',
                                  borderRadius: '10px',
                                  borderLeft: `4px solid ${
                                    environment.warningColor || '#F59E0B'
                                  }`,
                                  gridColumn: { xs: 'span 1', md: '1 / -1' },
                                  width: '100%',
                                }}
                              >
                                <Box
                                  sx={{
                                    flexShrink: 0,
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '50%',
                                    backgroundColor:
                                      environment.warningColor || '#F59E0B',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      color: 'white',
                                      fontSize: '13px',
                                      fontWeight: 700,
                                      fontFamily: 'Jost',
                                    }}
                                  >
                                    i
                                  </Typography>
                                </Box>
                                <Typography
                                  sx={{
                                    color: '#92400E',
                                    fontFamily: 'Jost',
                                    fontWeight: 500,
                                    fontSize: '13px',
                                    lineHeight: 1.6,
                                    flex: 1,
                                  }}
                                >
                                  <strong>Delivery Note:</strong> An additional
                                  45 min - 1 hour will be added to your
                                  scheduled time to ensure fresh delivery
                                </Typography>
                              </Box>
                            )}
                        </div>
                      </Box>
                    </Box>
                  )}
                </Grid>

                {/* end of schedule order */}
              </Stack>
            </Box>
          </Grid>
          <Grid
            item
            sm={12}
            lg={4}
            sx={{
              borderRadius: '16px',
              backgroundColor: 'white',
              boxShadow: '0px 0px 50px 0px #4545450D',
              height: 'fit-content',
              padding: '24px',
            }}
          >
            <OrderSummary
              typeTip={typeTip}
              setTypeTip={setTypeTip}
              otherTip={otherTip}
              setOtherTip={setOtherTip}
              setTipsAmount={setTipsAmount}
              tipAmount={tipAmount}
              defaultStore={defaultStore}
              defaultStorefee={defaultStorefee}
              filteredStore={filteredStore}
              storeIdD={storeIdD}
              onTipChange={handleTipChange}
              giftCardCode={giftCardCode}
              setGiftCardCode={setGiftCardCode}
              appliedGiftCard={appliedGiftCard}
              setAppliedGiftCard={setAppliedGiftCard}
              onGiftCardApply={calculatePriceWithUpdates}
            />

            <Grid>
              {' '}
              <p style={{ color: 'red' }}>{errAmount}</p>
            </Grid>

            {orderType != 'dinein' ? (
              <Grid item>
                <p
                  style={{
                    color: 'red',
                    alignSelf: 'flex-end',
                    textAlign: 'center',
                    width: '100%',
                    fontWeight: 'bold',
                    marginBottom: 10,
                    marginTop: '10px',
                  }}
                >
                  {err}
                </p>

                {/* Add More Items Button */}
                <div
                  className={classes.flexJustifyCenter}
                  style={{ marginBottom: '12px' }}
                >
                  <Button
                    variant="outlined"
                    onClick={handleBackToMenu}
                    disableRipple
                    sx={{
                      textTransform: 'capitalize',
                      padding: '14px 40px',
                      width: '320px',
                      boxShadow: 'none',
                      fontWeight: 600,
                      borderRadius: '43px',
                      backgroundColor: 'white',
                      color: environment.mainColor,
                      border: `2px solid ${environment.mainColor}`,
                      fontFamily: 'Jost',
                      '&:hover': {
                        backgroundColor: '#FFF4F0',
                        border: `2px solid ${environment.mainColor}`,
                        boxShadow: 'none',
                      },
                    }}
                  >
                    + Add More Items
                  </Button>
                </div>

                <div className={classes.flexJustifyCenter}>
                  {loading ? (
                    <div
                      className={classes.btnContainer}
                      style={{
                        backgroundColor: environment.mainColor,
                      }}
                    >
                      <p style={{ marginRight: 10 }}>
                        {t('confirmPage.please')}
                      </p>
                      <Snipper color={'white'} />
                    </div>
                  ) : unavailableNow ? (
                    <Button
                      disabled={true}
                      className={classes.confirmButton}
                      style={{
                        color: 'black',
                        width: !smDown && 300,
                      }}
                    >
                      {t('confirmPage.err')}
                    </Button>
                  ) : (!slots?.asap || selectedValue !== 'a') &&
                    !dateOfOrder ? (
                    <Button
                      disabled={true}
                      className={classes.confirmButton}
                      style={{
                        color: 'black',
                        width: !smDown && 300,
                      }}
                    >
                      {t('confirmPage.pleaseChooseTime')}
                    </Button>
                  ) : (
                    <div>
                      {activeorders.length >= 10 ? (
                        <Button
                          disabled={true}
                          className={classes.confirmButton}
                          style={{
                            color: 'black',
                            width: !smDown && 300,
                          }}
                        >
                          {t('confirmPage.activeOrder')}
                        </Button>
                      ) : (
                        // <CustomButton
                        //   buttonText={t('confirmPage.placeOrder')}
                        //   onClick={() => setConfirmDialog(true)}
                        //   bg={environment.mainColor}
                        //   style={{ textTransform:"capitalize" , padding:"16px 40px" , width:"320px" , boxShadow:"none" , fontWeight:600 ,  }}

                        // />
                        <Button
                          variant="contained"
                          onClick={async () => {
                            const ok = await validatePersonalInfo();
                            if (!ok) {
                              // Scroll into view for the section when invalid
                              try {
                                const el = document.querySelector(
                                  '[data-section="personal-info"]'
                                );
                                if (el && el.scrollIntoView)
                                  el.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'start',
                                  });
                              } catch (e) {}
                              return;
                            }
                            if (isScheduleExpired) {
                              setRescheduleDialogOpen(true);
                              return;
                            }
                            setConfirmDialog(true);
                          }}
                          sx={{
                            textTransform: 'capitalize',
                            padding: '16px 40px',
                            width: '320px',
                            boxShadow: 'none',
                            fontWeight: 600,
                            borderRadius: '43px',
                            backgroundColor: environment.mainColor,
                            fontFamily: 'Jost',
                            marginTop: '10px',
                            '&:hover': {
                              backgroundColor: environment.mainColor,
                              boxShadow: 'none',
                            },
                          }}
                        >
                          place your order
                        </Button>
                      )}
                    </div>
                  )}
                </div>
              </Grid>
            ) : (
              <>
                {' '}
                {/* Add More Items Button for dinein */}
                <div
                  className={classes.flexJustifyCenter}
                  style={{ marginTop: '10px', marginBottom: '12px' }}
                >
                  <Button
                    variant="outlined"
                    onClick={handleBackToMenu}
                    disableRipple
                    sx={{
                      textTransform: 'capitalize',
                      padding: '14px 40px',
                      width: smDown ? '100%' : '300px',
                      boxShadow: 'none',
                      fontWeight: 600,
                      borderRadius: '43px',
                      backgroundColor: 'white',
                      color: environment.mainColor,
                      border: `2px solid ${environment.mainColor}`,
                      fontFamily: 'Jost',
                      '&:hover': {
                        backgroundColor: '#FFF4F0',
                        border: `2px solid ${environment.mainColor}`,
                        boxShadow: 'none',
                      },
                    }}
                  >
                    + Add More Items
                  </Button>
                </div>
                {loading ? (
                  <div
                    className={classes.flexJustifyCenter}
                    style={{
                      marginTop: '13px',
                      marginBottom: '13px',
                    }}
                  >
                    <div
                      className={classes.btnContainer}
                      style={{
                        backgroundColor: environment.mainColor,
                      }}
                    >
                      <p style={{ marginRight: 10 }}>
                        {t('confirmPage.please')}
                      </p>
                      <Snipper color={'white'} />
                    </div>
                  </div>
                ) : (
                  <div
                    className={classes.flexJustifyCenter}
                    style={{
                      marginTop: '5px',
                    }}
                  >
                    {activeorders.length >= 10 ? (
                      <Button
                        disabled={true}
                        className={classes.confirmButton}
                        style={{
                          width: !smDown && 300,
                          color: 'black',
                        }}
                      >
                        {t('confirmPage.activeOrder')}
                      </Button>
                    ) : unavailableNow ? (
                      <Button
                        disabled={true}
                        className={classes.confirmButton}
                        style={{
                          width: !smDown && 300,
                          color: 'black',
                        }}
                      >
                        {t('confirmPage.err')}
                      </Button>
                    ) : (
                      <div style={{ marginTop: '10px' }}>
                        <CustomButton
                          buttonText={`${t('confirmPage.placeOrder')}`}
                          onClick={() => {
                            if (isScheduleExpired) {
                              setRescheduleDialogOpen(true);
                              return;
                            }
                            setConfirmDialog(true);
                          }}
                          bg={environment.mainColor}
                          disabled={loading}
                        />
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </Grid>
        </Grid>
        {/*  */}
        {/* SuccessDialog disabled per request */}
        <NewPaymet
          open={change === 'newCard' && openCredit}
          cards={cards}
          setCards={setCards}
          setOpen={setOpenCredit}
          handleChange={setChange}
          onSelect={onSelect}
          change={change}
          paymentFlow={env?.paymentFlow}
          onConfirmClover={onConfirmClover}
        />
      </Container>
      {(environment?.restaurantId === 'fattyPattyDev' ||
        environment?.restaurantId === 'fattyPatty') && <NeedQuestion />}

      {/* Payment Method Dialog */}
      <PaymentMethodDialog
        open={paymentMethodDialog}
        onClose={() => setPaymentMethodDialog(false)}
        onConfirm={handlePaymentMethodConfirm}
        onShowLoading={() => setLoading(true)}
        paymentMethod={paymentMethod}
        setPaymentMethod={setPaymentMethod}
        sourceId={sourceId}
        setSourceId={setSourceId}
        orderType={orderType}
        cards={cards}
        setCards={setCards}
        handleChange={setChange}
        onSelect={onSelect}
        change={change}
        openCredit={openCredit}
        setCredit={setOpenCredit}
        setSelectedCard={setUserCard}
        cash={cash}
        setCash={setCash}
        squarePaymentRef={squarePaymentRef}
        savedCards={savedCards}
        selectedSavedCardId={selectedSavedCardId}
        onSavedCardSelect={setSelectedSavedCardId}
        shouldSaveCard={shouldSaveCard}
        onSaveCardChange={setShouldSaveCard}
        useNewCard={useNewCard}
        onUseNewCardChange={setUseNewCard}
        onCardOptionSelect={fetchSavedCards}
        cashAppPayRef={cashAppPayRef}
        applePayRef={applePayRef}
        googlePayRef={googlePayRef}
        apiPricingData={apiPricingData}
        storeIdD={storeIdD}
        user={user}
        handleGooglePaySuccess={handleGooglePaySuccess}
        err={err}
        setErr={setErr}
      />

      <Dialog
        open={confirmDialog}
        onClose={closeConfirmDialog}
        PaperProps={{
          style: {
            borderRadius: '24px',
            padding: '8px',
            maxWidth: '480px',
            boxShadow: '0px 20px 60px rgba(0, 0, 0, 0.15)',
          },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            paddingBottom: '12px',
            borderBottom: '1px solid #E5E7EB',
          }}
        >
          <Box
            sx={{
              width: '48px',
              height: '48px',
              borderRadius: '12px',
              backgroundColor: `${environment?.mainColor}15`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <IoTime size={24} style={{ color: environment?.mainColor }} />
          </Box>
          <Typography
            sx={{
              fontSize: '20px',
              fontWeight: 700,
              color: '#172B4D',
              fontFamily: 'Jost, sans-serif',
            }}
          >
            {t('confirmPage.orderSupport')}
          </Typography>
        </DialogTitle>
        <DialogContent
          sx={{
            padding: '24px',
            minHeight: '120px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <DialogContentText
            sx={{
              fontSize: '16px',
              fontFamily: 'Jost, sans-serif',
              color: '#4B5563',
              lineHeight: 1.6,
              marginTop: '10px',
            }}
          >
            {selectedValue === 'a'
              ? orderType === 'delivery' || orderType === 'noDriverDelivery'
                ? t('confirmPage.chooseASAPdelivery')
                : `${asap}. Please confirm to continue.`
              : (() => {
                  // Helper: always 12-hour AM/PM format
                  const formatTimeWithPeriod = (timeStr) => {
                    if (!timeStr) return '';
                    const formatOne = (s) => {
                      const t = String(s).trim();
                      if (/AM|PM/i.test(t)) {
                        const m = t.match(
                          /^(\d{1,2}):(\d{1,2})(?::\d{1,2})?\s*(AM|PM)$/i
                        );
                        if (m)
                          return `${parseInt(m[1], 10)}:${String(
                            parseInt(m[2], 10) || 0
                          ).padStart(2, '0')} ${m[3].toUpperCase()}`;
                      }
                      const match = t.match(/(\d{1,2}):(\d{1,2})/);
                      if (match) {
                        let hour = parseInt(match[1], 10);
                        const minute = String(
                          parseInt(match[2], 10) || 0
                        ).padStart(2, '0');
                        const period = hour >= 12 ? 'PM' : 'AM';
                        hour = hour % 12 || 12;
                        return `${hour}:${minute} ${period}`;
                      }
                      return t;
                    };
                    if (timeStr.includes(' - ')) {
                      const [a, b] = timeStr.split(' - ');
                      return `${formatOne(a)} - ${formatOne(b)}`;
                    }
                    return formatOne(timeStr);
                  };

                  const formattedTime = formatTimeWithPeriod(selectedTime.data);

                  const dateLabel =
                    realTime === 'today'
                      ? 'Today'
                      : realTime === 'tomorrow'
                        ? 'Tomorrow'
                        : i18n.language === 'ar'
                          ? getTomorrow().after.dayInArabic
                          : getTomorrow().after.day +
                            ', ' +
                            getTomorrowScheduleLater();
                  const isDelivery =
                    orderType === 'delivery' ||
                    orderType === 'noDriverDelivery';

                  return (
                    <>
                      {isDelivery ? (
                        <>
                          Your order will be ready at{' '}
                          <strong>{formattedTime}</strong>{' '}
                          {realTime === 'today' ? 'today' : dateLabel},{' '}
                          and dispatched immediately for delivery.
                          <Box
                            component="span"
                            sx={{
                              display: 'block',
                              mt: 1.5,
                              fontSize: '14px',
                              color: '#6B7280',
                              fontFamily: 'Jost, sans-serif',
                              lineHeight: 1.4,
                            }}
                          >
                            You can expect it to arrive within 45–60 minutes
                            after pickup.
                          </Box>
                          <Box
                            component="span"
                            sx={{
                              display: 'block',
                              mt: 1,
                              fontSize: '14px',
                              color: '#6B7280',
                              fontFamily: 'Jost, sans-serif',
                              lineHeight: 1.4,
                            }}
                          >
                            Please confirm to continue.
                          </Box>
                        </>
                      ) : (
                        <>
                          Are you sure you want your order to be picked up on{' '}
                          <strong>{dateLabel}</strong> at{' '}
                          <strong>{formattedTime}</strong>?
                          <Box
                            component="span"
                            sx={{
                              display: 'block',
                              mt: 1.5,
                              fontSize: '14px',
                              color: '#6B7280',
                              fontFamily: 'Jost, sans-serif',
                              lineHeight: 1.4,
                            }}
                          >
                            Your order will be ready for pickup at the selected
                            time.
                          </Box>
                        </>
                      )}
                    </>
                  );
                })()}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            padding: '16px 24px',
            gap: 1,
            borderTop: '1px solid #E5E7EB',
          }}
        >
          <Button
            onClick={closeConfirmDialog}
            sx={{
              textTransform: 'none',
              color: '#6B7280',
              fontFamily: 'Jost, sans-serif',
              fontWeight: 600,
              fontSize: '15px',
              padding: '10px 24px',
              borderRadius: '12px',
              '&:hover': {
                backgroundColor: '#F3F4F6',
              },
            }}
          >
            {t('profilee.cancel')}
          </Button>
          <Button
            onClick={() => {
              // Safety net: if the scheduled slot expired between opening this dialog
              // and clicking Confirm, redirect to reschedule instead of proceeding.
              if (isScheduleExpired) {
                closeConfirmDialog();
                setRescheduleDialogOpen(true);
                return;
              }

              // Check if this is a gift card only payment
              const isGiftCardOnly =
                appliedGiftCard && apiPricingData?.remainingAmount <= 0;

              closeConfirmDialog();

              // If gift card only, proceed directly with order; otherwise open payment method dialog
              if (isGiftCardOnly) {
                onConfirm();
              } else {
                setPaymentMethodDialog(true);
              }
            }}
            disabled={loading}
            variant="contained"
            sx={{
              textTransform: 'none',
              backgroundColor: environment?.mainColor,
              color: 'white',
              fontFamily: 'Jost, sans-serif',
              fontWeight: 600,
              fontSize: '15px',
              padding: '10px 32px',
              borderRadius: '12px',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: environment?.mainColor,
                opacity: 0.9,
                boxShadow: 'none',
              },
            }}
          >
            {t('confirmPage.confirm')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Tip reset for gift-card-only: Square requires tips to be paid with a payment method */}
      <Dialog
        open={showTipResetForGiftCardDialog}
        onClose={() => setShowTipResetForGiftCardDialog(false)}
        PaperProps={{
          style: {
            borderRadius: '24px',
            padding: '8px',
            maxWidth: '440px',
            boxShadow: '0px 20px 60px rgba(0, 0, 0, 0.15)',
          },
        }}
      >
        <DialogTitle
          sx={{
            fontSize: '20px',
            fontWeight: 700,
            color: '#172B4D',
            fontFamily: 'Jost, sans-serif',
            paddingBottom: '8px',
            borderBottom: '1px solid #E5E7EB',
          }}
        >
          Reset tip to pay with gift card
        </DialogTitle>
        <DialogContent sx={{ padding: '24px 24px 8px' }}>
          <DialogContentText
            sx={{
              fontSize: '15px',
              fontFamily: 'Jost, sans-serif',
              color: '#4B5563',
              lineHeight: 1.6,
              marginY: '10px',
            }}
          >
            Tips cannot be paid with a gift card only. To complete your order
            with your gift card, we’ll set the tip to $0. Do you want to
            continue?
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            padding: '16px 24px',
            gap: 1,
            borderTop: '1px solid #E5E7EB',
          }}
        >
          <Button
            onClick={() => setShowTipResetForGiftCardDialog(false)}
            sx={{
              textTransform: 'none',
              color: '#6B7280',
              fontFamily: 'Jost, sans-serif',
              fontWeight: 600,
              fontSize: '15px',
              padding: '10px 24px',
              borderRadius: '12px',
              '&:hover': { backgroundColor: '#F3F4F6' },
            }}
          >
            {t('profilee.cancel')}
          </Button>
          <Button
            onClick={async () => {
              setShowTipResetForGiftCardDialog(false);
              setLoading(true);
              // Lock tip to a fixed custom value so percentage auto-recalc
              // logic does not override the forced $0 tip for gift-card-only.
              setTypeTip('other');
              setTipsAmount(0);
              try {
                await calculatePriceWithUpdates({ newTipAmount: 0 });
                setShouldProceedAfterTipReset(true);
              } catch (e) {
                setErr('Failed to update. Please try again.');
                setLoading(false);
              }
            }}
            disabled={loading}
            variant="contained"
            sx={{
              textTransform: 'none',
              backgroundColor: environment?.mainColor,
              color: 'white',
              fontFamily: 'Jost, sans-serif',
              fontWeight: 600,
              fontSize: '15px',
              padding: '10px 32px',
              borderRadius: '12px',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: environment?.mainColor,
                opacity: 0.9,
                boxShadow: 'none',
              },
            }}
          >
            {t('confirmPage.confirm')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* reCAPTCHA container for OTP verification */}
      <div id="recaptcha-container-checkout"></div>

      {/* OTP Verification Dialog */}
      <Dialog
        open={isPhoneVerification}
        onClose={() => {}}
        disableEscapeKeyDown
        PaperProps={{
          style: {
            borderRadius: '20px',
            // padding: '16px',
            maxWidth: '450px',
            width: '90%',
            boxShadow: '0px 20px 60px rgba(0, 0, 0, 0.15)',
          },
        }}
      >
        <DialogTitle
          sx={{
            fontSize: '22px',
            fontWeight: 700,
            color: '#172B4D',
            fontFamily: 'Jost, sans-serif',
            textAlign: 'center',
            paddingBottom: '8px',
          }}
        >
          Verify Your Phone Number
        </DialogTitle>
        <DialogContent sx={{ padding: { xs: '16px', sm: '16px 24px' } }}>
          <Typography
            sx={{
              fontSize: '14px',
              color: '#6B7280',
              marginBottom: '20px',
              textAlign: 'center',
              fontFamily: 'Jost, sans-serif',
            }}
          >
            Enter the verification code sent to {personalPhone}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              mb: 2,
              width: '100%',
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                '& > div': {
                  display: 'flex !important',
                  justifyContent: 'center !important',
                  alignItems: 'center',
                  flexWrap: 'nowrap',
                  width: '100%',
                  margin: '0 auto',
                },
              }}
            >
              <ReactCodeInput
                type="number"
                fields={6}
                value={OTP}
                onChange={handlePinChange}
                inputStyle={{
                  width: smDown ? '38px' : '45px',
                  height: smDown ? '45px' : '50px',
                  margin: smDown ? '0 2px' : '0 5px',
                  textAlign: 'center',
                  fontSize: smDown ? '18px' : '20px',
                  border: '2px solid #e0e0e0',
                  borderRadius: '10px',
                  fontFamily: 'Jost, sans-serif',
                  maxWidth: '100%',
                }}
                inputStyleInvalid={{
                  border: '2px solid #d32f2f',
                }}
              />
            </Box>
          </Box>
          {otpError && (
            <Typography
              variant="caption"
              color="error"
              sx={{ display: 'block', textAlign: 'center', mt: 1 }}
            >
              {otpError}
            </Typography>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            padding: { xs: '0 16px 16px 16px', sm: '0 24px 16px 24px' },
            flexDirection: 'column',
            gap: 1,
          }}
        >
          <Button
            fullWidth
            onClick={requestOTP}
            disabled={isSendingOTP}
            variant="outlined"
            sx={{
              textTransform: 'none',
              borderColor: environment?.mainColor,
              color: environment?.mainColor,
              fontFamily: 'Jost, sans-serif',
              fontWeight: 600,
              fontSize: '15px',
              padding: '10px',
              borderRadius: '12px',
              '&:hover': {
                borderColor: environment?.mainColor,
                backgroundColor: `${environment?.mainColor}10`,
              },
            }}
          >
            {isSendingOTP ? 'Sending...' : 'Resend Code'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Email Verification Dialog */}
      <Dialog
        open={showEmailDialog}
        onClose={() => {}}
        disableEscapeKeyDown
        PaperProps={{
          style: {
            borderRadius: '20px',
            padding: '12px',
            maxWidth: '500px',
            width: '90%',
            boxShadow: '0px 20px 60px rgba(0, 0, 0, 0.15)',
          },
        }}
      >
        <DialogTitle
          sx={{
            fontSize: '22px',
            fontWeight: 700,
            color: '#172B4D',
            fontFamily: 'Jost, sans-serif',
            textAlign: 'center',
            paddingBottom: '8px',
          }}
        >
          {isExistingUser
            ? 'Confirm Your Information'
            : 'Enter Your Information'}
        </DialogTitle>
        <DialogContent sx={{ padding: '16px 24px' }}>
          <Typography
            sx={{
              fontSize: '14px',
              color: '#6B7280',
              marginBottom: '16px',
              textAlign: 'center',
              fontFamily: 'Jost, sans-serif',
            }}
          >
            {isExistingUser
              ? 'Please verify or update your information.'
              : 'Please enter your information to continue.'}
          </Typography>
          {isExistingUser && !tempEmail && !tempFirstName && !tempLastName ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                py: 4,
              }}
            >
              <CircularProgress size={28} sx={{ color: environment?.mainColor }} />
            </Box>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  fullWidth
                  required
                  label="First Name"
                  type="text"
                  value={tempFirstName}
                  onChange={(e) => {
                    setTempFirstName(e.target.value);
                    setEmailDialogError('');
                  }}
                  error={!!emailDialogError && !tempFirstName.trim()}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '12px',
                      fontFamily: 'Jost, sans-serif',
                    },
                    '& .MuiInputLabel-root': {
                      fontFamily: 'Jost, sans-serif',
                    },
                  }}
                />
                <TextField
                  fullWidth
                  required
                  label="Last Name"
                  type="text"
                  value={tempLastName}
                  onChange={(e) => {
                    setTempLastName(e.target.value);
                    setEmailDialogError('');
                  }}
                  error={!!emailDialogError && !tempLastName.trim()}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '12px',
                      fontFamily: 'Jost, sans-serif',
                    },
                    '& .MuiInputLabel-root': {
                      fontFamily: 'Jost, sans-serif',
                    },
                  }}
                />
              </Box>
              <TextField
                fullWidth
                required
                label="Email Address"
                type="email"
                value={tempEmail}
                disabled={authHasEmailForDialog}
                onChange={(e) => {
                  setTempEmail(e.target.value);
                  setEmailDialogError('');
                }}
                onBlur={() => {
                  // Check if email has changed from the original when user leaves the field
                  console.log('📧 Email onBlur triggered', {
                    isExistingUser,
                    personalEmail,
                    tempEmail,
                  });
                  if (isExistingUser) {
                    // Compare with personalEmail (what was loaded from the user's account)
                    const originalEmail =
                      personalEmail || authUserData?.email || '';
                    const hasChanged =
                      tempEmail.trim().toLowerCase() !==
                      originalEmail.trim().toLowerCase();
                    setHasEmailChanged(hasChanged);
                    console.log('📧 Email change check:', {
                      originalEmail,
                      tempEmail,
                      hasChanged,
                      isExistingUser,
                    });
                  } else {
                    console.log('📧 Skipping check - not an existing user');
                  }
                }}
                error={
                  !!emailDialogError &&
                  (!tempEmail.trim() ||
                    emailDialogError.toLowerCase().includes('email'))
                }
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '12px',
                    fontFamily: 'Jost, sans-serif',
                  },
                  '& .MuiInputLabel-root': {
                    fontFamily: 'Jost, sans-serif',
                  },
                }}
              />
              {isExistingUser && hasEmailChanged && (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '8px',
                    padding: '12px 14px',
                    backgroundColor: '#EFF6FF',
                    borderRadius: '10px',
                    borderLeft: `4px solid ${
                      environment?.mainColor || '#3B82F6'
                    }`,
                  }}
                >
                  <Box
                    sx={{
                      flexShrink: 0,
                      width: '18px',
                      height: '18px',
                      borderRadius: '50%',
                      backgroundColor: environment?.mainColor || '#3B82F6',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginTop: '1px',
                    }}
                  >
                    <Typography
                      sx={{
                        color: 'white',
                        fontSize: '11px',
                        fontWeight: 700,
                        fontFamily: 'Jost',
                      }}
                    >
                      i
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      color: '#1E40AF',
                      fontFamily: 'Jost',
                      fontWeight: 500,
                      fontSize: '13px',
                      lineHeight: 1.5,
                      flex: 1,
                    }}
                  >
                    <strong>Note:</strong> You entered a different email
                    address. This will permanently update your account email,
                    not just for this order.
                  </Typography>
                </Box>
              )}
              {emailDialogError && (
                <Typography
                  sx={{
                    fontSize: '14px',
                    color: '#EF4444',
                    fontFamily: 'Jost, sans-serif',
                    textAlign: 'center',
                  }}
                >
                  {emailDialogError}
                </Typography>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px', gap: 1 }}>
          <Button
            fullWidth
            onClick={handleEmailSubmit}
            disabled={isUpdatingEmail}
            variant="contained"
            sx={{
              textTransform: 'none',
              backgroundColor: environment?.mainColor,
              color: 'white',
              fontFamily: 'Jost, sans-serif',
              fontWeight: 600,
              fontSize: '16px',
              padding: '12px',
              borderRadius: '12px',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: environment?.mainColor,
                opacity: 0.9,
                boxShadow: 'none',
              },
            }}
          >
            {isUpdatingEmail ? 'Verifying...' : 'Continue'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Loading component */}
      <Loading
        loading={!!loading || isSendingOTP}
        background="rgba(86, 100, 210, 0.1)"
        loaderColor={environment.mainColor}
      />

      {/* Reschedule dialog — shown when user tries to place an order after the selected time slot has passed */}
      <SchedulingDialog
        open={rescheduleDialogOpen}
        onClose={() => setRescheduleDialogOpen(false)}
        onConfirm={handleRescheduleConfirm}
        store={StoreData}
        orderType={orderType || 'pickup'}
        isStoreOpen={true}
        titleOverride="Your scheduled time has passed"
        subtitleOverride="Please choose a new time slot to continue with your order."
      />
    </>
  );
};
export default ConfirmOrderPage;
